import type { MessageKey } from './index';

// Polish translations. Keys mirror ./index; TypeScript enforces completeness.
export const pl: Record<MessageKey, string> = {
  'common.cancel': 'Anuluj',
  'common.stepperHint':
    'Kliknij, aby zmienić o krok (Shift ×10). Przytrzymaj i przeciągnij w górę lub w dół',
  'common.confirm': 'Potwierdź',
  'common.copied': 'Skopiowano',
  'common.create': 'Utwórz',
  'common.delete': 'Usuń',
  'renders.deleteSelected': 'Usuń zaznaczone ({n})',
  'renders.deleteAll': 'Usuń wszystkie',
  'renders.selectAll': 'Zaznacz wszystkie',
  'renders.deleteTitle': 'Usunąć tę generację?',
  'renders.deleteSelectedTitle': 'Usunąć zaznaczone generacje ({n})?',
  'renders.deleteAllTitle': 'Usunąć wszystkie generacje?',
  'renders.deleteFilteredTitle': 'Usunąć wszystkie generacje pasujące do filtrów?',
  'renders.deleteText':
    'Pliki zostaną usunięte na zawsze. Wykorzystane generacje z limitu planu nie wrócą.',
  'renders.deleted': 'Usunięto: {n}',
  'renders.skippedRunning': 'Wciąż w toku, nieusunięte: {n}',
  'batch.delete': 'Usuń uruchomienie',
  'batch.deleteTitle': 'Usunąć to uruchomienie i wszystkie jego generacje?',
  'batch.deleteText':
    'Zostaną usunięte wszystkie obrazy uruchomienia i archiwum ZIP. Wykorzystane generacje z limitu planu nie wrócą.',
  'automation.deleteWithRenders': 'Usuń też wszystkie wygenerowane banery',
  'err.batchRunning': 'Uruchomienie wciąż trwa — usuń je po zakończeniu.',
  'err.renderRunning': 'Generacja wciąż trwa — usuń ją po zakończeniu.',
  'audit.renders.deleted': 'Usunięto generacje:',
  'common.download': 'Pobierz',
  'common.edit': 'Edytuj',
  'common.error': 'Błąd',
  'common.height': 'Wysokość',
  'common.width': 'Szerokość',
  'common.import': 'Importuj',
  'nav.admin': 'Panel admina',
  'billing.testMode': 'Tryb testowy superadmina',
  'billing.testModeHint':
    'Natychmiast zmienia plan tej przestrzeni roboczej bez płatności — aby sprawdzić limity.',
  'billing.manual': 'ręcznie',
  'admin.title': 'Panel admina',
  'admin.description':
    'Wszyscy użytkownicy i przestrzenie robocze na platformie. Widoczne tylko dla superadminów.',
  'admin.overview': 'Przegląd',
  'admin.users': 'Użytkownicy',
  'admin.usersHint': '+{n7} w 7 dni · +{n30} w 30 dni',
  'admin.active7': 'Zalogowani, 7 dni',
  'admin.blockedN': 'Zablokowani: {n}',
  'admin.renders30': 'Generowania, 30 dni',
  'admin.rendersHint': 'Dziś {today} · błędy {failed}',
  'admin.mrr': 'MRR (subskrypcje)',
  'admin.paying': 'Płacące przestrzenie robocze: {n}',
  'admin.workspacesByPlan': 'Przestrzenie robocze wg planu · {n}',
  'admin.ai30': 'AI, 30 dni',
  'admin.aiRequests': 'zapytania',
  'admin.aiCost': 'koszt modelu',
  'admin.search': 'Szukaj po e-mailu lub nazwie',
  'admin.user': 'Użytkownik',
  'admin.workspaces': 'Przestrzenie robocze',
  'admin.workspace': 'Przestrzeń robocza',
  'admin.signedUp': 'Rejestracja',
  'admin.lastLogin': 'Ostatnie logowanie',
  'admin.sessions': 'aktywne sesje: {n}',
  'admin.blocked': 'zablokowany',
  'admin.block': 'Zablokuj',
  'admin.unblock': 'Odblokuj',
  'admin.blockTitle': 'Zablokować {email}?',
  'admin.blockText':
    'Użytkownik zostanie wylogowany wszędzie i nie zaloguje się, dopóki nie zostanie odblokowany. Jego przestrzenie robocze i klucze API nadal działają.',
  'admin.blockedDone': 'Użytkownik zablokowany',
  'admin.unblockedDone': 'Użytkownik odblokowany',
  'admin.signOut': 'Wyloguj wszędzie',
  'admin.signedOutDone': 'Sesje zakończone',
  'admin.delete': 'Usuń',
  'admin.deleteTitle': 'Usunąć {email}?',
  'admin.deleteText':
    'Konto zostanie usunięte na zawsze wraz z przestrzeniami, w których użytkownik jest jedynym członkiem: szablony, pliki, rendery. Odmowa, jeśli jest właścicielem wspólnej przestrzeni lub ma płatną subskrypcję.',
  'admin.deletedDone': 'Użytkownik usunięty',
  'admin.plan': 'Plan',
  'admin.planSet': '„{name}” ma teraz plan {plan}',
  'admin.manual': 'ręcznie',
  'admin.templates': 'Szablony',
  'admin.renders30short': 'Generowania 30 dni',
  'admin.storage': 'Miejsce',
  'admin.lastRender': 'Ostatnie generowanie',
  'admin.members': 'członkowie: {n}',
  'common.back': 'Wstecz',
  'common.next': 'Dalej',
  'legal.privacy': 'Polityka prywatności',
  'legal.terms': 'Regulamin',
  'legal.privacyLower': 'Politykę prywatności',
  'legal.termsLower': 'Regulamin',
  'legal.and': 'i',
  'legal.consentPrefix': 'Rejestrując się, akceptujesz',
  'legal.updated': 'Ostatnia aktualizacja: {date}',
  'legal.home': 'Wróć na stronę główną',
  'help.title': 'Pomoc i dokumenty prawne',
  'help.support': 'Wsparcie',
  'help.apiDocs': 'Dokumentacja API',
  'help.apiDocsHint': 'Endpointy, parametry, przykłady',
  'help.termsHint': 'Zasady korzystania z serwisu',
  'help.privacyHint': 'Jakie dane przechowujemy i dlaczego',
  'preview.final': 'Finalny obraz bez znaku wodnego',
  'preview.watermarkHint': 'Bezpłatnie: podgląd ze znakiem wodnym nie zużywa planu.',
  'preview.finalHint': 'Zużywa 1 generowanie z Twojego planu.',
  'billing.fPreviews': 'Bezpłatne podglądy ze znakiem wodnym',
  'showcase.badge': 'Edytor',
  'showcase.title': 'Edytor, który trzyma układ w ryzach',
  'showcase.subtitle':
    'To nie tylko płótno ze współrzędnymi: stosy jak w Figmie, inteligentne skalowanie do dowolnego rozmiaru i precyzyjne odstępy. Zmień rozmiar — to prawdziwe generowanie.',
  'showcase.render': 'Generuj',
  'showcase.layers': 'Warstwy',
  'showcase.clickHint': 'Kliknij warstwę lub zmień rozmiar',
  'showcase.layer': 'Warstwa',
  'showcase.apiField': 'Nazwa warstwy = pole API i kolumna tabeli',
  'showcase.stack': 'Stos (auto layout)',
  'showcase.resize': 'Zmiana rozmiaru',
  'showcase.resizeText':
    'Warstwy dopasowują się według swoich reguł — jeden szablon na każdą platformę.',
  'showcase.altHint': 'Alt — odległości do sąsiadów',
  'showcase.p1Title': 'Stosy jak w Figmie',
  'showcase.p1Text': 'Długi tekst z API odsuwa sąsiednie elementy zamiast na nie nachodzić.',
  'showcase.p2Title': 'Jeden szablon, każdy rozmiar',
  'showcase.p2Text': 'Post, relacja i baner z jednego projektu, z dopasowanymi warstwami.',
  'showcase.p3Title': 'Precyzyjne odstępy',
  'showcase.p3Text': 'Przyciąganie, prowadnice i odległości do sąsiadów z Alt.',
  'showcase.p4Title': 'Gotowy do automatyzacji',
  'showcase.p4Text': 'Każda warstwa jest od razu dostępna w API, tabelach i linkach.',
  'motionShowcase.badge': 'Animacja',
  'motionShowcase.title': 'Statyczny baner w animację jednym kliknięciem',
  'motionShowcase.subtitle':
    'Kliknij „Ożyw”: nagłówek, zdjęcie, cena i przycisk same dostaną swój ruch. Bez osi czasu i klatek kluczowych.',
  'motionShowcase.static': 'Statyczny',
  'motionShowcase.animated': 'Animacja',
  'motionShowcase.formats': 'MP4 · WebM · GIF',
  'motionShowcase.hint': 'To prawdziwy render: przełączaj style',
  'motionShowcase.p1Title': 'Jedno kliknięcie',
  'motionShowcase.p1Text':
    'Serwis sam rozpoznaje nagłówek, zdjęcie, cenę i przycisk i nadaje każdej warstwie własne wejście w kolejności czytania.',
  'motionShowcase.p2Title': 'Styl do zadania',
  'motionShowcase.p2Text':
    'Płynny, energiczny, wyprzedaż, kinetyczny, elegancki i inne. Wynik możesz dopracować ręcznie.',
  'motionShowcase.p3Title': 'Setki animowanych kreacji',
  'motionShowcase.p3Text':
    'Ten sam szablon z arkusza, feedu lub API daje MP4, WebM i GIF we wszystkich rozmiarach, także Stories i Reels.',
  'previewMode.title': 'Tryb podglądu',
  'previewMode.text':
    'Każdy obraz generowany w przestrzeni roboczej — przez API, automatyzacje, linki i edytor — dostaje znak wodny i nie zużywa limitu. Przydatne podczas konfigurowania integracji; wyłącz, gdy wszystko będzie gotowe.',
  'previewMode.on': 'Tryb podglądu jest włączony',
  'previewMode.off': 'Tryb podglądu jest wyłączony',
  'previewMode.banner': 'Tryb podglądu: wszystkie obrazy mają znak wodny i nie zużywają limitu.',
  'previewMode.manage': 'Wyłącz',
  'linked.masterChip': 'Zestaw: {n} rozm.',
  'linked.sizeChip': 'Rozmiar „{name}”',
  'linked.changedN': 'zmienione: {n}',
  'linked.setTitle': 'Powiązane rozmiary',
  'linked.addSize': 'Dodaj rozmiar',
  'linked.addSizeHint':
    'Ten sam projekt w innym rozmiarze. Zmiany oryginału trafiają do wszystkich rozmiarów, a ręczne zmiany rozmiaru zostają',
  'linked.addSizeTileHint': 'Story, post, baner — zmiany się przenoszą',
  'linked.resetAll': 'Cofnij wszystkie zmiany tego rozmiaru',
  'linked.unlink': 'Odłącz od oryginału',
  'linked.masterHint':
    'Zmiany w tym szablonie trafiają do każdego rozmiaru. To, co zostało zmienione ręcznie w danym rozmiarze, jest zachowywane.',
  'linked.sizeHint':
    'Zmiany w oryginale trafiają tu automatycznie. Warstwy zmienione tutaj są oznaczone kropką i nie są nadpisywane.',
  'linked.layerChanged': 'Zmieniona w tym rozmiarze — zmiany w oryginale jej nie nadpiszą',
  'linked.resetLayer': 'Przywróć',
  'linked.changesTitle': 'Zmieniono w tym rozmiarze',
  'linked.changesHint': 'Co ten rozmiar zmienił względem oryginału i jak to cofnąć',
  'linked.selectLayer': 'Zaznacz warstwę',
  'linked.resetLayerHint': 'Przywróć warstwę jak w oryginale',
  'linked.resetAdded': 'Usuń',
  'linked.resetRemoved': 'Przywróć',
  'linked.changeAdded': 'tylko w tym rozmiarze',
  'linked.changeRemoved': 'usunięta w tym rozmiarze',
  'linked.propPosition': 'położenie',
  'linked.propSize': 'rozmiar',
  'linked.propRotation': 'obrót',
  'linked.propLayout': 'układ',
  'linked.propText': 'tekst',
  'linked.propFont': 'czcionka',
  'linked.propColor': 'kolor',
  'linked.propImage': 'obraz',
  'linked.propVisibility': 'widoczność',
  'linked.propMotion': 'animacja',
  'linked.propOther': 'właściwości',
  'linked.option': 'Powiąż z oryginałem',
  'linked.optionHint':
    'Zmiany w oryginale automatycznie trafiają do tego rozmiaru; Twoje zmiany w nim są zachowywane.',
  'linked.optionPaid':
    'Powiązane rozmiary są dostępne w planach Pro i Business: edytujesz jeden szablon, aktualizują się wszystkie rozmiary.',
  'linked.badgeSize': 'powiązany rozmiar',
  'linked.badgeMaster': 'zestaw · {n}',
  'billing.fLinked': 'Powiązane rozmiary',
  'quality.title': 'Kontrola jakości',
  'quality.found': '{n} z {total} banerów ma problemy',
  'quality.clean': 'Kontrola jakości: nie znaleziono problemów ({total})',
  'quality.checking': 'Sprawdzanie jakości w miarę generowania obrazów…',
  'quality.hint':
    'Ucięty lub mocno pomniejszony tekst, brakujące lub rozmyte obrazy, warstwy poza płótnem.',
  'quality.showIssues': 'Pokaż tylko z problemami',
  'quality.showAll': 'Pokaż wszystkie',
  'quality.markerTitle': 'Problemy: {n}',
  'issue.text_overflow': 'tekst się nie mieści i jest ucięty',
  'issue.text_shrunk': 'tekst pomniejszony z {from} do {to} px, aby się zmieścił',
  'issue.image_missing': 'nie udało się wczytać obrazu',
  'issue.image_lowres': 'obraz {width}×{height} rozciągnięty {upscale}× — będzie rozmyty',
  'issue.offcanvas': 'warstwa jest poza płótnem',
  'linked.original': 'oryginał',
  'linked.setHeader': 'Zestaw „{name}”',
  'linked.setCount': 'Rozmiary: {n}',
  'linked.setHint': 'zmiany w oryginale trafiają do każdego rozmiaru',
  'linked.filterAll': 'Wszystkie',
  'linked.filterSets': 'Zestawy',
  'linked.filterSingles': 'Pojedyncze',
  'linked.backToAll': 'Wszystkie szablony',
  'linked.allSizes': 'Wszystkie rozmiary',
  'linked.allSizesHint':
    'Pokaż wszystkie rozmiary zestawu obok siebie na jednym płótnie. Zmiany oryginału od razu widać we wszystkich rozmiarach',
  'linked.openSize': 'Kliknij, aby edytować ten rozmiar',
  'linked.fitAll': 'Pokaż wszystkie rozmiary',
  'linked.fitCurrent': 'Tylko otwarty rozmiar',
  'editor.paddingX': 'Lewo i prawo',
  'editor.paddingY': 'Góra i dół',
  'editor.paddingSides': 'Każda strona osobno',
  'editor.paddingAxes': 'W poziomie i w pionie',
  'editor.pad_top': 'Góra',
  'editor.pad_right': 'Prawo',
  'editor.pad_bottom': 'Dół',
  'editor.pad_left': 'Lewo',
  'billing.status.active': 'aktywna',
  'billing.status.trialing': 'okres próbny',
  'billing.status.past_due': 'płatność nieudana',
  'billing.status.unpaid': 'nieopłacona',
  'billing.status.canceled': 'anulowana',
  'billing.status.expired': 'zakończona',
  'billing.card': 'Karta {brand} •••• {last4}',
  'billing.graceTitle': 'Płatność nieudana',
  'billing.graceText':
    'Zaktualizuj metodę płatności — w przeciwnym razie po {date} przestrzeń robocza przejdzie z planu {plan} na Free.',
  'billing.unpaidTitle': 'Subskrypcja zawieszona',
  'billing.unpaidText':
    'Nie otrzymaliśmy płatności, więc przestrzeń robocza jest na planie Free. Zaktualizuj kartę — plan wróci zaraz po płatności.',
  'billing.updateCard': 'Zaktualizuj metodę płatności',
  'billing.history': 'Historia płatności',
  'billing.invoice': 'Faktura',
  'billing.reason.initial': 'Subskrypcja',
  'billing.reason.renewal': 'Odnowienie',
  'billing.reason.update': 'Zmiana planu',
  'billing.graceBanner': 'Płatność nieudana — plan działa do {date}:',
  'billing.graceBannerLink': 'Zaktualizuj kartę',
  'admin.prices': 'Ceny',
  'admin.pricesHint':
    'Ceny planów w każdej walucie. Odwiedzający widzą walutę swojego kraju, a płatności są pobierane w {currency}.',
  'admin.currencyOn': 'Pokazuj',
  'admin.perMonth': 'miesięcznie',
  'admin.perYear': 'rocznie',
  'admin.pricesSaved': 'Ceny zapisane',
  'admin.pricesReset': 'Ceny domyślne',
  'admin.chargeCurrency': 'waluta płatności',
  'billing.chargedMonth': 'Pobieramy {amount} miesięcznie',
  'billing.chargedYear': 'Pobieramy {amount} rocznie',
  'billing.billedYearly': '{amount} płatne rocznie',
  'err.network': 'Brak połączenia z serwerem. Sprawdź internet i spróbuj ponownie.',
  'err.seePlans': 'Plany',
  'err.internal': 'Coś poszło nie tak po naszej stronie. Spróbuj ponownie za minutę.',
  'err.validation': 'Sprawdź wypełnione pola.',
  'err.notFound': 'Nie znaleziono — możliwe, że zostało już usunięte.',
  'err.forbidden': 'Nie masz uprawnień do tej akcji.',
  'err.tooLarge': 'Plik jest za duży.',
  'err.rateLimited': 'Za dużo żądań. Spróbuj ponownie za {seconds} s.',
  'err.signIn': 'Sesja wygasła — zaloguj się ponownie.',
  'err.notMember': 'Nie jesteś członkiem tej przestrzeni roboczej.',
  'err.roleRequired': 'Wymagana rola „{role}” lub wyższa.',
  'err.templateLimit':
    'Twój plan pozwala na maks. {limit} szablonów. Przejdź na wyższy plan, aby utworzyć więcej.',
  'err.membersLimit':
    'Twój plan pozwala na maks. {limit} członków. Przejdź na wyższy plan, aby zaprosić więcej osób.',
  'err.automationsLimit':
    'Twój plan pozwala na maks. {limit} automatyzacji. Przejdź na wyższy plan, aby dodać więcej.',
  'err.customSizesLimit': 'Plan {plan} pozwala zapisać maks. {limit} własnych rozmiarów.',
  'err.customSizesPlan':
    'Własne rozmiary nie są dostępne w planie {plan}. Przejdź na wyższy plan, aby je zapisywać.',
  'err.rendersLimit':
    'Wykorzystano miesięczny limit generowań ({used} z {limit} w planie {plan}). Przejdź na wyższy plan, aby kontynuować.',
  'err.aiLimit': 'Wykorzystano miesięczny limit zapytań AI ({used} z {limit} w planie {plan}).',
  'err.storageLimit':
    'Miejsce na pliki jest pełne (limit: {mb} MB). Usuń niepotrzebne pliki lub przejdź na wyższy plan.',
  'err.batchLimit':
    'Plan {plan} generuje maks. {limit} obrazów na uruchomienie (żądano: {requested}).',
  'err.scaleLimit': 'Skala {scale}× nie jest dostępna w planie {plan} (maks. {max}×).',
  'err.scaleTooLarge':
    'Szablon „{name}” można powiększyć najwyżej {max}x: obraz ma najwyżej {side} px na bok i {mpx} Mpx.',
  'err.outputTooLarge':
    'Obraz miałby {width}×{height} px, a maksimum to {max} px na bok. Użyj mniejszej skali.',
  'err.linkedSizesPlan': 'Powiązane rozmiary są dostępne od planu Pro.',
  'err.customFontsPlan': 'Własne czcionki są dostępne od planu Pro.',
  'err.integrationsPlan': 'Google Drive i S3 są dostępne w płatnych planach.',
  'err.schedulePlan': 'Uruchamianie według harmonogramu jest dostępne od planu Pro.',
  'err.signedUrlsPlan': 'Podpisane linki do obrazów są dostępne w płatnych planach.',
  'err.templateInvalid':
    'Szablon jest uszkodzony i nie można go zapisać. Odśwież stronę i spróbuj ponownie.',
  'err.sizeRange': 'Szerokość i wysokość to liczby całkowite od {min} do {max} px.',
  'err.templateConflict':
    'Szablon został zmieniony w innej karcie lub przez kogoś z zespołu. Odśwież stronę, aby pobrać najnowszą wersję.',
  'err.notLinkedSize': 'Ten szablon nie jest powiązany z głównym.',
  'err.layerInvalid': 'Warstwa „{layer}”: {detail}',
  'err.batchEmpty': 'Nie ma czego generować: brak wierszy.',
  'err.zipNotReady': 'Archiwum ZIP jeszcze się przygotowuje — chwilę poczekaj.',
  'err.fileTooLarge': 'Plik jest za duży: maks. {mb} MB.',
  'err.imageType':
    'Obsługiwane: obrazy PNG, JPG, WEBP, GIF, AVIF i SVG, wideo MP4, MOV i WEBM oraz muzyka MP3, M4A, WAV, OGG i FLAC.',
  'err.imageDownload': 'Nie udało się pobrać obrazu z linku (HTTP {status}).',
  'err.urlUnreachable': 'Link jest niedostępny. Sprawdź adres — musi być publiczny.',
  'err.noFile': 'Wybierz plik.',
  'err.fontType': 'Prześlij czcionkę w formacie TTF, OTF, WOFF lub WOFF2.',
  'err.fontFamilyRequired': 'Podaj nazwę czcionki.',
  'err.csvParse': 'Nie udało się odczytać pliku CSV: {detail}',
  'err.jsonInvalid': 'Link nie zwraca JSON.',
  'err.jsonShape': 'JSON musi być listą obiektów (lub {"rows": [...]}).',
  'err.sheetLink': 'To nie wygląda na link do Arkuszy Google.',
  'err.sheetPrivate':
    'Arkusz jest prywatny. Udostępnij go opcją „Każda osoba mająca link” lub połącz konto Google.',
  'err.sourceAccessDenied': 'Odmowa dostępu do danych (HTTP {status}).',
  'err.sourceHttp': 'Źródło danych zwróciło błąd (HTTP {status}).',
  'err.sourceEmpty': 'Źródło danych nie ma wierszy.',
  'err.noHeaderRow': 'Plik nie ma wiersza z nagłówkami kolumn.',
  'err.apiSource':
    'Ta automatyzacja otrzymuje wiersze przez API — uruchom ją żądaniem POST /v1/automations/{id}/runs.',
  'err.apiRowsRequired': 'Przekaż wiersze („rows”), aby uruchomić.',
  'err.templatesMissing': 'Niektóre wybrane szablony już nie istnieją — wybierz je ponownie.',
  'err.templatesGone': 'Wybrane szablony już nie istnieją — wybierz inne.',
  'err.scheduleApi': 'Automatyzacji z danymi z API nie można uruchamiać według harmonogramu.',
  'err.cronInvalid': 'Harmonogram jest nieprawidłowy.',
  'err.endpointInvalid': 'Adres serwera: {detail}',
  'err.bucketWrite': 'Nie udało się zapisać do bucketu: {detail}',
  'err.signupsDisabled': 'Rejestracja na tym serwerze jest zamknięta.',
  'err.emailTaken': 'Konto z tym adresem email już istnieje — zaloguj się.',
  'err.badCredentials': 'Nieprawidłowy email lub hasło.',
  'err.accountBlocked': 'To konto jest zablokowane. Skontaktuj się z pomocą techniczną.',
  'err.resetInvalid': 'Link do resetu hasła jest nieważny lub wygasł — poproś o nowy.',
  'err.wrongPassword': 'Obecne hasło jest nieprawidłowe.',
  'err.googleDisabled': 'Google nie jest skonfigurowany na tym serwerze.',
  'err.googleError': 'Google zwrócił błąd: {detail}',
  'err.googleNoRefresh':
    'Google nie przyznał stałego dostępu. Usuń dostęp aplikacji na koncie Google i połącz ponownie.',
  'err.googleNoEmail': 'Twoje konto Google nie ma potwierdzonego adresu email.',
  'err.googleOtherAccount': 'Ten email jest powiązany z innym kontem Google.',
  'err.ownerOnlyTransfer': 'Tylko właściciel może przekazać własność.',
  'err.lastOwner': 'Przestrzeń robocza musi mieć co najmniej jednego właściciela.',
  'err.ownerOnlyRemoveOwner': 'Tylko właściciel może usunąć właściciela.',
  'err.inviteOwner': 'Zaproś jako administratora, a własność przekaż później.',
  'err.alreadyMember': 'Ta osoba jest już w przestrzeni roboczej.',
  'err.invitationInvalid': 'To zaproszenie jest nieważne lub wygasło.',
  'err.invitationOtherEmail':
    'Zaproszenie wysłano na {email}. Zaloguj się tym adresem, aby je przyjąć.',
  'err.adminOnlyRemove': 'Tylko administratorzy mogą usuwać członków.',
  'err.onlyWorkspace': 'Nie możesz usunąć jedynej przestrzeni roboczej.',
  'err.cancelBeforeDelete': 'Najpierw anuluj subskrypcję, potem usuń przestrzeń roboczą.',
  'err.blockSelf': 'Nie możesz zablokować samego siebie.',
  'err.deleteSelf': 'Nie możesz usunąć samego siebie.',
  'err.deleteSuperadmin': 'Nie możesz usunąć superadministratora.',
  'err.paymentsDisabled': 'Płatności nie są skonfigurowane na tym serwerze.',
  'err.paymentProvider': 'Serwis płatności zwrócił błąd — spróbuj ponownie.',
  'err.planNotForSale': 'Tego planu nie można jeszcze kupić.',
  'err.noSubscription': 'Ta przestrzeń robocza nie ma jeszcze subskrypcji.',
  'err.portalUnavailable': 'Panel płatności jest teraz niedostępny — spróbuj później.',
  'err.cancelInPortal': 'Anuluj subskrypcję w panelu płatności.',
  'err.planSwitchDisabled': 'Zmiana planu bez płatności jest wyłączona.',
  'err.pricesChargeCurrency':
    'Wymagane są ceny w {currency}: w tej walucie pobierane są płatności.',
  'err.aiDisabled': 'Funkcje AI są wyłączone na tym serwerze.',
  'err.aiBusy': 'AI jest teraz przeciążone — spróbuj za minutę.',
  'err.code.bad_request': 'Nie udało się — sprawdź dane i spróbuj ponownie.',
  'err.code.validation_error': 'Sprawdź wypełnione pola.',
  'err.code.unauthorized': 'Zaloguj się.',
  'err.code.forbidden': 'Nie masz uprawnień do tej akcji.',
  'err.code.not_found': 'Nie znaleziono — możliwe, że zostało już usunięte.',
  'err.code.conflict': 'Konflikt z aktualnymi danymi — odśwież stronę.',
  'err.code.plan_limit': 'Niedostępne w Twoim planie.',
  'err.code.quota_exceeded': 'Osiągnięto limit Twojego planu.',
  'err.code.payment_required': 'Wymagany jest płatny plan.',
  'err.code.rate_limited': 'Za dużo żądań — spróbuj za minutę.',
  'err.code.payload_too_large': 'Plik jest za duży.',
  'err.code.unsupported_media_type': 'Ten typ pliku nie jest obsługiwany.',
  'err.code.internal_error': 'Coś poszło nie tak po naszej stronie. Spróbuj ponownie za minutę.',
  'err.code.service_unavailable': 'Usługa jest chwilowo niedostępna — spróbuj później.',
  'err.field.required': 'Wypełnij pole „{field}”',
  'err.field.choose': 'Wybierz co najmniej jedno: „{field}”',
  'err.field.minLength': '„{field}”: minimalna długość — {n}',
  'err.field.maxLength': '„{field}”: maksymalna długość — {n}',
  'err.field.min': '„{field}”: co najmniej {n}',
  'err.field.max': '„{field}”: maks. {n}',
  'err.field.email': 'Podaj prawidłowy adres email',
  'err.field.url': '„{field}”: podaj pełny link zaczynający się od https://',
  'err.field.invalid': 'Sprawdź pole „{field}”',
  'field.name': 'Nazwa',
  'field.templateIds': 'Szablony',
  'field.dataSource.url': 'Link do danych',
  'field.dataSource.rows': 'Tabela',
  'field.dataSource.columns': 'Kolumny tabeli',
  'field.dataSource.sheet': 'Arkusz',
  'field.dataSource.integrationId': 'Konto Google',
  'field.mapping.rules.layer': 'Warstwa w regule',
  'field.mapping.rules.column': 'Kolumna w regule',
  'field.mapping.rules.value': 'Wartość w regule',
  'field.output.formats': 'Formaty plików',
  'field.output.scale': 'Skala',
  'field.output.quality': 'Jakość',
  'field.output.filenamePattern': 'Nazwy plików',
  'field.destinations.url': 'URL webhooka',
  'field.destinations.folderName': 'Folder na Google Drive',
  'field.destinations.integrationId': 'Konto do eksportu',
  'field.destinations.prefix': 'Folder w buckecie',
  'field.schedule.cron': 'Harmonogram',
  'field.schedule.timezone': 'Strefa czasowa',
  'field.email': 'Email',
  'field.password': 'Hasło',
  'field.newPassword': 'Nowe hasło',
  'field.currentPassword': 'Obecne hasło',
  'field.workspaceName': 'Nazwa przestrzeni roboczej',
  'field.width': 'Szerokość',
  'field.height': 'Wysokość',
  'field.brief': 'Opis',
  'field.text': 'Tekst',
  'field.url': 'Link',
  'field.bucket': 'Bucket',
  'field.region': 'Region',
  'field.endpoint': 'Adres serwera (endpoint)',
  'field.publicBaseUrl': 'Publiczny adres plików',
  'field.accessKeyId': 'Access Key ID',
  'field.secretAccessKey': 'Secret Access Key',
  'field.defaultWebhookUrl': 'Domyślny webhook',
  'field.family': 'Nazwa czcionki',
  'field.tags': 'Tagi',
  'field.format': 'Format',
  'field.scale': 'Skala',
  'field.quality': 'Jakość',
  'field.modifications': 'Dane warstw',
  'common.more': 'Więcej',
  'common.name': 'Nazwa',
  'common.notFound': 'Nie znaleziono',
  'common.nothingFound': 'Nic nie znaleziono',
  'common.open': 'Otwórz',
  'common.openNewTab': 'Otwórz w nowej karcie',
  'common.save': 'Zapisz',
  'common.saved': 'Zapisano',
  'common.search': 'Szukaj',
  'common.uploading': 'Przesyłanie…',
  'role.owner': 'Właściciel',
  'role.admin': 'Administrator',
  'role.editor': 'Edytor',
  'role.viewer': 'Obserwator',
  'nav.templates': 'Szablony',
  'nav.automations': 'Automatyzacje',
  'nav.renders': 'Wygenerowane obrazy',
  'nav.assets': 'Biblioteka mediów',
  'nav.fonts': 'Czcionki',
  'nav.api': 'API i klucze',
  'nav.integrations': 'Integracje',
  'nav.settings': 'Ustawienia',
  'nav.billing': 'Plan i płatności',
  'nav.developers': 'Dla programistów',
  'nav.workspace': 'Przestrzeń robocza',
  'nav.workspaces': 'Przestrzenie robocze',
  'nav.newWorkspace': 'Nowa przestrzeń robocza',
  'nav.profile': 'Profil',
  'nav.logout': 'Wyloguj się',
  'nav.rendersThisMonth': 'Generowania w tym okresie',
  'nav.upgrade': 'Zmień plan',
  'auth.google': 'Kontynuuj z Google',
  'auth.or': 'lub',
  'auth.error.google_denied': 'Logowanie przez Google zostało anulowane',
  'auth.error.google_state': 'Sesja logowania wygasła, spróbuj ponownie',
  'auth.error.google_failed': 'Nie udało się zalogować przez Google',
  'auth.error.google_unavailable': 'Logowanie przez Google nie jest skonfigurowane na tym serwerze',
  'settings.setPassword': 'Ustaw hasło',
  'settings.googleNoPassword':
    'Logujesz się przez Google. Ustaw hasło, aby logować się także adresem e-mail.',
  'auth.loginTitle': 'Zaloguj się do Bannermatic',
  'auth.loginSubtitle': 'Witaj ponownie',
  'auth.signupTitle': 'Utwórz konto',
  'auth.signupSubtitle': 'Plan Free — bez karty płatniczej',
  'auth.email': 'E-mail',
  'auth.password': 'Hasło',
  'auth.passwordHint': 'Co najmniej 8 znaków',
  'auth.name': 'Imię',
  'auth.company': 'Firma lub zespół',
  'auth.companyHint': 'Nazwa przestrzeni roboczej — możesz ją później zmienić',
  'auth.forgot': 'Nie pamiętasz hasła?',
  'auth.loginButton': 'Zaloguj się',
  'auth.signupButton': 'Utwórz konto',
  'auth.noAccount': 'Nie masz konta?',
  'auth.haveAccount': 'Masz już konto?',
  'auth.signupLink': 'Zarejestruj się',
  'auth.loginLink': 'Zaloguj się',
  'auth.freePlanNote': '50 bezpłatnych generowań co miesiąc',
  'auth.forgotTitle': 'Zresetuj hasło',
  'auth.forgotSubtitle': 'Wyślemy Ci link do resetu e-mailem',
  'auth.forgotSent': 'Jeśli konto istnieje, e-mail jest już w drodze. Sprawdź skrzynkę.',
  'auth.sendLink': 'Wyślij link',
  'auth.resetTitle': 'Ustaw nowe hasło',
  'auth.newPassword': 'Nowe hasło',
  'auth.resetButton': 'Zapisz hasło',
  'auth.resetDone': 'Hasło zmienione — zaloguj się',
  'invite.title': 'Zaproszenie do zespołu',
  'invite.text': 'Zaproszono Cię do „{workspace}” z rolą {role}.',
  'invite.accept': 'Przyjmij zaproszenie',
  'invite.signup': 'Utwórz konto dla {email}',
  'templates.description': 'Szablony banerów z dynamicznymi warstwami dla API i automatyzacji',
  'templates.new': 'Nowy szablon',
  'templates.newTitle': 'Nowy szablon',
  'templates.untitled': 'Bez nazwy',
  'templates.createAndEdit': 'Utwórz i otwórz edytor',
  'templates.customSize': 'Własny rozmiar',
  'templates.groupSocial': 'Media społecznościowe',
  'templates.groupAds': 'Reklamy displayowe',
  'templates.groupWeb': 'Strony WWW i e-mail',
  'templates.groupVideo': 'Wideo',
  'templates.groupPrint': 'Druk',
  'templates.count': 'Łącznie: {n}',
  'templates.emptyTitle': 'Utwórz swój pierwszy szablon',
  'templates.emptyText':
    'Zaprojektuj baner, nadaj warstwom czytelne nazwy i generuj setki wariantów przez API lub arkusz kalkulacyjny.',
  'templates.duplicateAs': 'Kopia w innym rozmiarze',
  'templates.duplicateAsHint':
    'Warstwy dopasują się zgodnie ze swoim zachowaniem przy zmianie rozmiaru — potem sprawdź układ.',
  'templates.duplicated': 'Kopia utworzona',
  'sizes.mine': 'Twoje rozmiary',
  'sizes.standard': 'Standardowe',
  'sizes.save': 'Zapisz rozmiar',
  'sizes.saved': 'Rozmiar zapisany w przestrzeni roboczej',
  'sizes.paid': 'Własne rozmiary dla dowolnej platformy — od planu Starter',
  'sizes.limit': 'Twój plan pozwala na maksymalnie {n} własnych rozmiarów',
  'sizes.namePlaceholder': 'Nazwa, np. „Ekran w lobby”',
  'billing.fSizes': 'Do {n} własnych rozmiarów',
  'billing.fSizesUnlimited': 'Nieograniczona liczba własnych rozmiarów',
  'templates.copyName': '{name} (kopia)',
  'duplicate.menu': 'Duplikuj…',
  'duplicate.title': 'Duplikuj szablon',
  'duplicate.sameSize': 'Ten sam rozmiar {size}',
  'duplicate.otherSize': 'Inny rozmiar + auto layout',
  'templates.exportJson': 'Eksportuj JSON',
  'templates.importTitle': 'Importuj szablon',
  'templates.importHint':
    'SVG z Figmy (Copy as SVG lub Export → SVG), pliki .json z Bannermatic lub eksport Placid — kilka naraz',
  'templates.dropJson': 'Przeciągnij pliki lub kliknij, aby wybrać',
  'templates.figmaTitle': 'Jak wyeksportować z Figmy',
  'templates.figmaStep1': 'Zaznacz ramkę banera (Frame, nie grupę).',
  'templates.figmaStep2': 'W Export w prawym dolnym rogu kliknij „+” i wybierz SVG.',
  'templates.figmaStep3':
    'Kliknij „…” obok SVG i odznacz „Outline text” — teksty zostaną tekstami.',
  'templates.figmaStep4': 'Kliknij Export i przeciągnij plik .svg tutaj.',
  'templates.figmaNote':
    'Szybciej: PPM na ramce → Copy/Paste as → Copy as SVG i Ctrl+V (⌘V) tutaj, ale teksty przyjdą wtedy jako krzywe. Brakujące fonty zostaną zastąpione podobnymi i podświetlone — wgraj je, by było jeden do jednego.',
  'templates.svg.fontsReplaced':
    'Brakuje fontów z projektu, tymczasowo zastąpiono: {fonts}. Te teksty są podświetlone w edytorze — wgraj fonty i zastosuj je jednym kliknięciem.',
  'templates.svg.uploadFonts': 'Wgraj fonty',
  'templates.svg.outlined':
    'Teksty w tym SVG są zamienione na krzywe i nie da się ich edytować. W Figmie: Export → SVG → „…” → odznacz „Outline text” i zaimportuj ponownie. Albo zaznacz taki obraz w edytorze → „To tekst?”.',
  'editor.missingFontTitle': 'Font „{font}” nie jest wgrany',
  'editor.missingFontText':
    'Tekst jest wyświetlany fontem {used} — tak też wyjdzie w renderze. Wgraj font na stronie „Fonty”, a tutaj pojawi się przycisk „Zastosuj”.',
  'editor.missingFontFound': 'Font {font} jest już w przestrzeni.',
  'editor.missingFontApply': 'Zastosuj {font}',
  'editor.missingFontUpload': 'Wgraj font',
  'editor.missingFontKeep': 'Zostaw {used}',
  'editor.fontNotInWorkspace':
    'Tej czcionki nie ma w przestrzeni. Edytor może ją pokazywać z czcionek Twojego komputera, ale w renderach tekst będzie inną czcionką. Prześlij plik czcionki lub wybierz inną.',
  'editor.textFromImageTitle': 'To tekst?',
  'editor.textFromImageHint':
    'Figma często eksportuje teksty jako krzywe. Zamień ten obraz w edytowalny tekst w tym samym miejscu.',
  'editor.textFromImageManual': 'Zastąp warstwą tekstu',
  'editor.textFromImagePlaceholder': 'Tekst',
  'templates.importButton': 'Import: Figma, JSON',
  'templates.importing': 'Importuję… obrazy trafiają do biblioteki mediów',
  'templates.importFormats': 'SVG z Figmy · .json Bannermatic · eksport Placid',

  'templates.svg.invalid': 'Nie udało się odczytać SVG. Wyeksportuj ramkę z Figmy jako SVG',
  'templates.svg.empty': 'Nie znaleziono warstw w pliku SVG',
  'templates.svg.tooMany': 'SVG ma ponad 500 warstw — uprość projekt',
  'templates.imported': 'Szablon zaimportowany',
  'templates.deleteTitle': 'Usunąć szablon?',
  'templates.deleteText': '„{name}” przestanie być dostępny dla API i automatyzacji.',
  'gallery.open': 'Biblioteka szablonów',
  'gallery.title': 'Biblioteka szablonów',
  'gallery.description':
    'Gotowe układy zbudowane na stosach: wstaw swoje teksty i obrazy lub zmień rozmiar — układ się dopasuje.',
  'gallery.all': 'Wszystkie',
  'gallery.use': 'Użyj',
  'gallery.created': 'Szablon utworzony',
  'gallery.fromLibrary': 'Lub zacznij od gotowego szablonu',
  'gallery.cat.sale': 'Wyprzedaże',
  'gallery.cat.ecommerce': 'Produkty',
  'gallery.cat.event': 'Wydarzenia',
  'gallery.cat.social': 'Social media',
  'gallery.cat.food': 'Jedzenie i kawiarnie',
  'gallery.cat.realestate': 'Nieruchomości',
  'gallery.cat.education': 'Edukacja',
  'gallery.cat.hiring': 'Rekrutacja',
  'gallery.cat.travel': 'Podróże',
  'gallery.cat.fitness': 'Fitness',
  'gallery.cat.holiday': 'Święta',
  'gallery.cat.ads': 'Banery internetowe',
  'gallery.cat.beauty': 'Uroda',
  'gallery.cat.auto': 'Motoryzacja',
  'gallery.cat.tech': 'Technologie',
  'gallery.cat.pets': 'Zwierzęta',
  'ai.create': 'Utwórz z AI',
  'ai.regenerate': 'Więcej wariantów',
  'ai.credits': 'Zapytania AI: {used} z {limit} w tym miesiącu',
  'ai.disabled': 'Generowanie AI nie jest skonfigurowane na serwerze (GEMINI_API_KEY).',
  'aiVideo.title': 'Wideo z opisu',
  'aiVideo.placeholder': 'Np. premiera aplikacji Nova do montażu, 48% szybciej, ciemny styl',
  'aiVideo.generate': 'Utwórz wideo',
  'aiVideo.generating': 'AI reżyseruje warianty…',
  'aiVideo.style_launch': 'Premiera produktu',
  'aiVideo.style_showreel': 'Showreel',
  'aiVideo.style_manifesto': 'Manifest',
  'aiVideo.style_data': 'Historia w liczbach',
  'aiVideo.style_brand': 'Film marki',
  'director.title': 'Reżyser AI',
  'director.description':
    'Opisz, czego potrzebujesz i do czego. Agent sam złoży film lub baner narzędziami edytora: sceny, teksty i czcionki, zdjęcia, grafikę ruchomą, efekty tekstu, przejścia, kamerę i muzykę. Potem edytujesz go jak zwykły szablon.',
  'director.video': 'Wideo',
  'director.banner': 'Baner',
  'director.placeholderVideo':
    'Np. film premierowy aplikacji Nova do montażu. Odbiorcy: twórcy. Najważniejsze: montaż o 48% szybszy. Energicznie, ciemno z pomarańczowym, na końcu „Pobierz za darmo”.',
  'director.placeholderBanner':
    'Np. baner letniej wyprzedaży butów RUNNER, -30% do niedzieli, jasny i sportowy, przycisk „Kup teraz”.',
  'director.run': 'Utwórz',
  'director.again': 'Inna wersja',
  'director.open': 'Otwórz w edytorze',
  'director.mockNote': 'Tryb testowy bez klucza API: agent odtwarza przygotowany scenariusz.',
  'director.logHint': 'Tu zobaczysz, jak agent składa projekt krok po kroku.',
  'director.thinking': 'Agent obmyśla pomysł i scenorys…',
  'director.working': 'Agent pracuje · krok {n}',
  'director.fixed': 'Błędy poprawione po drodze: {n}',
  'director.previewHint': 'Tu pojawi się wynik',
  'director.tool_plan_style': 'Styl',
  'director.tool_add_scene': 'Scena',
  'director.tool_add_text': 'Tekst',
  'director.tool_add_shape': 'Kształt',
  'director.tool_add_photo': 'Zdjęcie',
  'director.tool_add_graphic': 'Grafika',
  'director.tool_add_camera': 'Kamera',
  'director.tool_set_music': 'Muzyka',
  'director.tool_finish': 'Gotowe',
  'director.tool_add_logo': 'Logo',
  'director.tool_update': 'Poprawka',
  'director.tool_remove': 'Usunięcie',
  'director.tool_update_scene': 'Edycja sceny',
  'director.tool_review': 'Przegląd',
  'director.reviewFound': 'uwag: {n} — poprawiam',
  'director.reviewClean': 'brak uwag',
  'director.brandDefault': 'Marka: {name}',
  'director.brandNone': 'Bez marki',
  'director.brandHint':
    'Kolory, czcionki i logo z brand kitu: projekt pozostanie powiązany z marką',
  'dictation.start': 'Dyktuj',
  'dictation.stop': 'Zatrzymaj dyktowanie',
  'dictation.listening': 'Słucham…',
  'dictation.lang': 'Język dyktowania',
  'dictation.denied': 'Brak dostępu do mikrofonu — zezwól na niego w przeglądarce',
  'dictation.failed': 'Nie udało się rozpoznać mowy',
  'ai.copyVariants': 'Warianty tekstu od AI',
  'ai.copyHint': 'Kliknij, aby użyć wariantu. Cofnij za pomocą Ctrl+Z.',
  'billing.fAi': 'Zapytania AI miesięcznie: {n}',
  'billing.aiPeriod': 'Zapytania AI w bieżącym okresie',
  'editor.dropImages': 'Upuść, aby przesłać pliki',
  'editor.saved': 'Zapisano',
  'editor.unsaved': 'Niezapisane zmiany',
  'editor.saving': 'Zapisywanie…',
  'editor.saveError': 'Nie udało się zapisać',
  'editor.conflict': 'Konflikt wersji',
  'editor.conflictTitle': 'Szablon został zmieniony gdzie indziej',
  'editor.conflictText':
    'Ktoś zapisał ten szablon, gdy go edytowałeś. Nadpisać go Twoją wersją? „Anuluj” wczyta najnowszą wersję.',
  'editor.overwrite': 'Nadpisz',
  'editor.undo': 'Cofnij',
  'editor.redo': 'Ponów',
  'editor.zoomIn': 'Powiększ',
  'editor.zoomOut': 'Pomniejsz',
  'editor.zoomFit': 'Dopasuj do ekranu',
  'editor.zoom100': 'Powiększenie 100%',
  'editor.selectAll': 'Zaznacz wszystkie warstwy',
  'editor.rename': 'Zmień nazwę',
  'editor.resize': 'Zmień rozmiar',
  'editor.testRender': 'Generuj',
  'editor.readOnly': 'Masz dostęp tylko do podglądu.',
  'editor.tabElements': 'Elementy',
  'editor.tabMedia': 'Media',
  'editor.tabLayers': 'Warstwy',
  'editor.text': 'Tekst',
  'editor.addHeading': 'Nagłówek',
  'editor.addSubheading': 'Podtytuł',
  'editor.addBody': 'Tekst główny',
  'editor.presetHeading': 'Nagłówek',
  'editor.presetSubheading': 'Podtytuł',
  'editor.presetBody': 'Tekst główny. Kliknij dwukrotnie, aby edytować.',
  'editor.addBadge': 'Plakietka −30%',
  'editor.shapes': 'Kształty',
  'editor.shapeRectangle': 'Prostokąt',
  'editor.shapeRounded': 'Zaokrąglony',
  'editor.shapeEllipse': 'Elipsa',
  'editor.shapeTriangle': 'Trójkąt',
  'editor.shapeLine': 'Linia',
  'editor.shapeDiamond': 'Romb',
  'editor.shapePolygon': 'Wielokąt',
  'editor.shapeStar': 'Gwiazda',
  'editor.shapeBurst': 'Wybuch',
  'editor.shapeHeart': 'Serce',
  'editor.shapeArrow': 'Strzałka',
  'editor.shapeChevron': 'Szewron',
  'editor.shapeCross': 'Plus',
  'editor.shapeBubble': 'Dymek',
  'editor.shapeRibbon': 'Wstęga',
  'editor.shapeTag': 'Metka',
  'editor.shapeParallelogram': 'Równoległobok',
  'editor.shapeSemicircle': 'Półkole',
  'editor.shapeBlob': 'Plama',
  'editor.shapeIcon': 'Ikona',
  'editor.shapePoints': 'Ramiona',
  'editor.shapeSides': 'Boki',
  'editor.shapeInner': 'Głębokość',
  'editor.secTextStyles': 'Style tekstu',
  'editor.secStickers': 'Naklejki i odznaki',
  'editor.secIcons': 'Ikony',
  'editor.secInfo': 'Kontakt i informacje',
  'editor.secDecor': 'Ramki i dekoracje',
  'editor.secOverlays': 'Tła i nakładki',
  'editor.iconSearch': 'Szukaj: phone, gift, star…',
  'editor.noIcons': 'Nic nie znaleziono',
  'editor.showAllIcons': 'Pokaż wszystkie ({n})',
  'editor.showLess': 'Pokaż mniej',
  'editor.elCta': 'Przycisk',
  'editor.txtCta': 'Kup teraz',
  'editor.elKicker': 'Nadtytuł',
  'editor.txtKicker': 'Nowość sezonu',
  'editor.elHighlight': 'Zakreślacz',
  'editor.txtHighlight': 'Tylko dziś',
  'editor.elOutline': 'Kontur',
  'editor.elNeon': 'Neon',
  'editor.txtNeon': 'Otwarte',
  'editor.elScript': 'Odręczny',
  'editor.txtScript': 'Z miłością',
  'editor.elElegant': 'Elegancki',
  'editor.elPoster': 'Plakat',
  'editor.elQuote': 'Cytat',
  'editor.txtQuote': '„Najlepsza kawa w mieście!”',
  'editor.elPrice': 'Cena promocyjna',
  'editor.elFineprint': 'Przypis',
  'editor.txtFineprint': '*Oferta ważna do 31 grudnia',
  'editor.elSale': 'Wyprzedaż',
  'editor.txtSale': 'SALE',
  'editor.elDiscount': 'Rabat',
  'editor.elNew': 'Nowość',
  'editor.txtNew': 'NOWOŚĆ',
  'editor.elRibbon': 'Wstęga',
  'editor.txtRibbon': 'BESTSELLER',
  'editor.elTag': 'Metka',
  'editor.elBubble': 'Dymek',
  'editor.txtBubble': 'Wow!',
  'editor.elLove': 'Serce',
  'editor.elShipping': 'Dostawa',
  'editor.txtShipping': 'Darmowa dostawa',
  'editor.elRating': 'Ocena',
  'editor.elTimer': 'Odliczanie',
  'editor.elPhone': 'Telefon',
  'editor.elAddress': 'Adres',
  'editor.txtAddress': 'ul. Główna 1',
  'editor.elWebsite': 'Strona',
  'editor.elDate': 'Data',
  'editor.txtDate': '12 maja · 19:00',
  'editor.elSocial': 'Social media',
  'editor.elChecklist': 'Lista',
  'editor.txtChecklist': 'Zaleta {n}',
  'editor.elFrame': 'Ramka',
  'editor.elDashedFrame': 'Ramka przerywana',
  'editor.elRing': 'Pierścień',
  'editor.elDivider': 'Akcent',
  'editor.elDottedLine': 'Kropki',
  'editor.elCircles': 'Koła',
  'editor.elBlob': 'Plama',
  'editor.elShadeBottom': 'Cień od dołu',
  'editor.elShadeTop': 'Cień od góry',
  'editor.elShadeLeft': 'Cień z lewej',
  'editor.elVignette': 'Winieta',
  'editor.elTint': 'Tonowanie',
  'editor.elDuotone': 'Duoton',
  'editor.elHalfPanel': 'Połowa',
  'editor.elDiagonal': 'Skos',
  'editor.elArc': 'Łuk na dole',
  'editor.stockPhotos': 'Zdjęcia',
  'editor.stockHint':
    'Zdjęcia royalty-free: możesz ich używać w banerach komercyjnych bez podawania autora. Kliknij, aby wstawić lub zastąpić zaznaczony obraz.',
  'editor.photoTag.all': 'Wszystkie',
  'editor.photoTag.people': 'Ludzie',
  'editor.photoTag.beauty': 'Uroda',
  'editor.photoTag.food': 'Jedzenie',
  'editor.photoTag.travel': 'Podróże',
  'editor.photoTag.home': 'Dom',
  'editor.photoTag.business': 'Biznes',
  'editor.photoTag.sport': 'Sport',
  'editor.photoTag.holiday': 'Święta',
  'editor.photoTag.auto': 'Auto',
  'editor.photoTag.pets': 'Zwierzęta',
  'editor.photoTag.nature': 'Natura',
  'editor.dynamic': 'Dynamiczne',
  'editor.imagePlaceholder': 'Zdjęcie / logo',
  'editor.qr': 'Kod QR',
  'editor.dynamicHint':
    'Każdą warstwę można zmienić przez API po jej nazwie: tekst, obraz, kolor, położenie.',
  'editor.noLayers': 'Brak warstw. Dodaj tekst, kształt lub obraz.',
  'editor.uploadImages': 'Prześlij zdjęcia lub wideo',
  'editor.uploadNew': 'Prześlij nowe',
  'editor.mediaHint':
    'Kliknij, aby wstawić lub zastąpić zaznaczony obraz. Możesz też upuścić pliki na płótno.',
  'editor.noUploads': 'Brak przesłanych plików',
  'editor.removeImage': 'Usuń obraz',
  'editor.placeholderImage': 'Symbol zastępczy — obraz pochodzi z API',
  'editor.replaceImage': 'Zastąp zdjęcie lub wideo',
  'editor.dropToReplace': 'Upuść, aby zastąpić',
  'editor.chooseImage': 'Wybierz zdjęcie lub wideo',
  'editor.imageUrl': 'lub wklej URL obrazu',
  'editor.template': 'Szablon',
  'editor.canvasSize': 'Rozmiar płótna',
  'editor.customSize': 'Własny rozmiar',
  'editor.resizeHint':
    'Przy włączonym dopasowaniu warstwy zachowują się zgodnie ze swoimi regułami zmiany rozmiaru. Cofnij za pomocą Ctrl+Z.',
  'editor.background': 'Tło',
  'editor.transparentHint': 'Przezroczyste tło jest zachowywane w PNG i WEBP.',
  'editor.tips': 'Wskazówki',
  'editor.tipNames':
    'Nadawaj warstwom czytelne nazwy (title, photo, price) — to do nich przypisywane są dane w API i arkuszach.',
  'editor.tipShortcuts':
    'Ctrl+Z / Ctrl+Shift+Z, Ctrl+D duplikuje, strzałki przesuwają (Shift ×10), Ctrl+kółko powiększa, Spacja przesuwa widok, przytrzymaj Alt, aby mierzyć odległości.',
  'editor.tipTools':
    'Narzędzia: R prostokąt, U zaokrąglony, O elipsa, L linia, T tekst, H nagłówek (Shift+H podtytuł), B plakietka, I zdjęcie, Q QR. Przeciągnij na płótnie lub kliknij; V lub Esc, aby zaznaczać.',
  'editor.toolHint': '{tool}: przeciągnij na płótnie lub kliknij · Esc, aby anulować',
  'editor.tipDrop': 'Upuść obrazy na płótno, aby je przesłać.',
  'editor.nameInvalid': 'Nazwa nie może zawierać . = & ? # / \\',
  'editor.nameTaken': 'Ta nazwa jest już używana',
  'editor.layerNameHint': 'Nazwa warstwy to klucz API i kolumna arkusza',
  'editor.layerDescription': 'Opis dla API (opcjonalnie)',
  'editor.position': 'Położenie i rozmiar',
  'editor.constraints': 'Zachowanie przy zmianie rozmiaru',
  'editor.constraintsHint': 'Jak warstwa dopasowuje się, gdy zmienia się rozmiar szablonu.',
  'editor.cH': 'W poziomie',
  'editor.cV': 'W pionie',
  'editor.c.auto': 'Auto',
  'editor.c.left': 'Do lewej',
  'editor.c.right': 'Do prawej',
  'editor.c.top': 'Do góry',
  'editor.c.bottom': 'Do dołu',
  'editor.c.center': 'Środek',
  'editor.c.stretch': 'Rozciągnij',
  'editor.c.scale': 'Skaluj',
  'editor.c.proportional': 'proporcjonalnie',
  'editor.adaptLayers': 'Dopasuj warstwy',
  'editor.applySize': 'Zastosuj rozmiar',
  'resize.preview': 'Podgląd',
  'resize.extremeWarning': 'Proporcje mocno się zmieniają — sprawdź układ po skopiowaniu.',
  'editor.stack': 'Stos',
  'editor.stackExpand': 'Pokaż warstwy stosu',
  'editor.stackCollapse': 'Zwiń stos',
  'editor.groupStack': 'W stos',
  'editor.ungroupStack': 'Rozgrupuj',
  'editor.stackLayout': 'Auto layout',
  'editor.dirVertical': 'Kolumna',
  'editor.dirHorizontal': 'Wiersz',
  'editor.dirAuto': 'Auto',
  'editor.dirFree': 'Brak',
  'editor.dirFreeHint':
    'Bez automatycznego układu: warstwy zostają tam, gdzie je postawiono (tekst na przycisku), i przesuwają się razem ze stosem. Kolumna lub wiersz ułoży je automatycznie.',
  'editor.dirAutoHint':
    'Auto: wiersz, gdy płótno jest co najmniej N razy szersze niż wyższe, w przeciwnym razie kolumna — jeden projekt dla rozmiarów poziomych i pionowych.',
  'editor.autoRowRatio': 'Wiersz od N : 1',
  'editor.gap': 'Odstęp',
  'editor.alignItems': 'Wyrównanie',
  'editor.al.start': 'Początek',
  'editor.al.center': 'Środek',
  'editor.al.end': 'Koniec',
  'editor.al.stretch': 'Rozciągnij',
  'editor.distribution': 'Rozmieszczenie',
  'editor.js.start': 'Początek',
  'editor.js.center': 'Środek',
  'editor.js.end': 'Koniec',
  'editor.js.space-between': 'Równomiernie',
  'editor.clip': 'Przycinaj zawartość',
  'editor.inStack': 'W stosie „{name}”',
  'editor.selectStack': 'Zaznacz stos',
  'editor.grow': 'Wypełnij wolne miejsce',
  'editor.earlier': 'Wcześniej',
  'editor.later': 'Później',
  'editor.stackHint':
    'Warstwy w stosie układają się automatycznie: dłuższy tekst odsuwa kolejne elementy.',
  'editor.stackFeatText': 'Dłuższy tekst sam odsuwa kolejne warstwy',
  'editor.stackFeatGrow':
    'Warstwa może zająć wolne miejsce: włącz „Wypełnij wolne miejsce” w warstwie',
  'editor.stackFeatAuto': '„Auto”: wiersz w szerokich rozmiarach, kolumna w wysokich',
  'editor.groupHint': 'Ctrl+G łączy zaznaczenie w stos, Ctrl+Shift+G rozgrupowuje.',
  'editor.copy': 'Kopiuj',
  'editor.paste': 'Wklej',
  'editor.alignToPage': 'Wyrównaj do strony',
  'editor.alignSelection': 'Wyrównaj',
  'editor.order': 'Kolejność',
  'editor.setAsBackground': 'Ustaw jako tło',
  'editor.editText': 'Edytuj tekst',
  'editor.moreActions': 'Więcej działań',
  'editor.opacityShort': 'Krycie',
  'editor.alignLeft': 'Wyrównaj do lewej',
  'editor.alignHCenter': 'Wyśrodkuj w poziomie',
  'editor.alignRight': 'Wyrównaj do prawej',
  'editor.alignTop': 'Wyrównaj do góry',
  'editor.alignVCenter': 'Wyśrodkuj w pionie',
  'editor.alignBottom': 'Wyrównaj do dołu',
  'editor.justify': 'Wyjustuj',
  'editor.distributeH': 'Rozmieść w poziomie',
  'editor.distributeV': 'Rozmieść w pionie',
  'editor.arrange': 'Warstwa',
  'editor.bringFront': 'Przenieś na wierzch',
  'editor.bringForward': 'Przesuń do przodu',
  'editor.sendBackward': 'Przesuń do tyłu',
  'editor.sendBack': 'Przenieś na spód',
  'editor.lock': 'Zablokuj',
  'editor.unlock': 'Odblokuj',
  'editor.hide': 'Ukryj',
  'editor.show': 'Pokaż',
  'editor.duplicate': 'Duplikuj',
  'editor.layersSelected': 'Zaznaczone warstwy: {n}',
  'editor.clearSelection': 'Wyczyść zaznaczenie',
  'editor.typography': 'Typografia',
  'editor.italic': 'Kursywa',
  'editor.lineHeight': 'Interlinia',
  'editor.lineHeightShort': '↕',
  'editor.letterSpacing': 'Odstęp między literami',
  'editor.letterSpacingShort': '↔',
  'editor.transformNone': 'Jak wpisano',
  'editor.uppercase': 'WIELKIE LITERY',
  'editor.lowercase': 'małe litery',
  'editor.capitalize': 'Wielkie Pierwsze',
  'editor.dynamicText': 'Długi tekst',
  'editor.autoFit': 'Zmniejszaj czcionkę, aby zmieścić tekst w polu',
  'editor.minFontSize': 'Min. rozmiar',
  'editor.maxLines': 'Maks. wierszy',
  'editor.autoFitHint':
    'Przydatne dla tekstu z API: krótki tekst zostaje duży, długi się zmniejsza. 0 wierszy = bez limitu.',
  'editor.textBox': 'Tło tekstu',
  'editor.padding': 'Odstępy wewnętrzne',
  'editor.radius': 'Zaokrąglenie',
  'editor.effects': 'Efekty',
  'editor.stroke': 'Obrys',
  'editor.shadow': 'Cień',
  'editor.blurShort': 'Rozmycie',
  'editor.image': 'Obraz lub wideo',
  'editor.fitCover': 'Wypełnij',
  'editor.fitContain': 'Zmieść',
  'editor.fitFill': 'Rozciągnij',
  'editor.focusX': 'Punkt ostrości X',
  'editor.focusY': 'Punkt ostrości Y',
  'editor.videoClip': 'Wideo',
  'editor.videoClipHint': 'Klip {s} s: gra w animacjach i wideo; obrazy pokazują pierwszą klatkę.',
  'editor.videoLoop': 'Zapętl',
  'editor.videoSound': 'Z dźwiękiem',
  'editor.videoVolume': 'Głośność',
  'editor.videoTrim': 'Fragment klipu',
  'editor.videoRemove': 'Zostaw tylko klatkę',
  'editor.videoPlay': 'Podgląd wideo',
  'editor.videoPause': 'Zatrzymaj podgląd',
  'editor.videoMute': 'Wycisz',
  'editor.videoUnmute': 'Włącz dźwięk',
  'err.videoUnreadable': 'Nie udało się odczytać wideo: prześlij MP4, MOV lub WEBM.',
  'editor.imageApiHint':
    'Przekaż URL przez API: {"photo": "https://…"}. Zdjęcie jest kadrowane wokół punktu ostrości.',
  'editor.style': 'Styl',
  'editor.border': 'Obramowanie',
  'editor.brightness': 'Jasność',
  'editor.blur': 'Rozmycie',
  'editor.grayscale': 'Skala szarości',
  'editor.flipX': 'Odbij w poziomie',
  'editor.flipY': 'Odbij w pionie',
  'editor.shape': 'Kształt',
  'editor.line': 'Linia',
  'editor.width': 'Grubość',
  'editor.strokeSolid': 'Ciągła',
  'editor.strokeDashed': 'Kreskowana',
  'editor.strokeDotted': 'Kropkowana',
  'editor.qrColor': 'Kolor',
  'editor.qrMargin': 'Margines',
  'editor.qrLevel': 'Poziom korekcji błędów',
  'editor.pickColor': 'Wybierz kolor',
  'editor.docColors': 'Kolory szablonu',
  'fold.autoFit': 'dopasowanie czcionki',
  'fold.maxLines': 'do {n} wierszy',
  'fold.words': 'słowa: {n}',
  'fold.numbers': 'liczby',
  'accent.bar': 'Akcent',
  'accent.bold': 'Pogrubienie',
  'accent.underline': 'Podkreślenie',
  'accent.marker': 'Zakreślacz',
  'accent.markerOn': 'Dodaj zakreślacz',
  'accent.markerOff': 'Usuń zakreślacz',
  'accent.remove': 'Usuń akcent',
  'accent.more': 'Własny kolor, zakreślacz, rozmiar…',
  'accent.textColor': 'Tekst',
  'accent.size': 'Rozmiar',
  'accent.wordTitle': 'Akcent „{word}”',
  'accent.dragHint': 'Przeciągnij, aby widzieć całą kompozycję',
  'accent.title': 'Akcenty w tekście',
  'accent.hint':
    'Kliknij dwukrotnie tekst, zaznacz słowo i wybierz kolor nad nim albo dodaj słowo tutaj. Słowo jest wyróżnione w każdym tekście, w którym występuje, także w danych z tabeli.',
  'accent.wordPlaceholder': 'Słowo lub fraza',
  'accent.add': 'Dodaj',
  'accent.dataTitle': 'Akcent z danych',
  'accent.numbers': 'Liczby i procenty jako akcent',
  'accent.dataHint':
    'W tabeli lub API: **słowo** w tekście komórki, kolumna „{layer}.accent” ze słowem (kilka oddzielonych „;”) albo „{layer}.accent_color” z kolorem.',
  'editor.colorOpacity': 'Krycie',
  'editor.fillNone': 'Brak',
  'editor.fillSolid': 'Jednolity',
  'editor.fillLinear': 'Liniowy',
  'editor.fillRadial': 'Radialny',
  'editor.angle': 'Kąt',
  'editor.addStop': 'Dodaj punkt',
  'editor.searchFonts': 'Szukaj czcionek',
  'editor.manageFonts': 'Zarządzaj czcionkami i przesyłaj je',
  'editor.weight100': 'Thin',
  'editor.weight200': 'ExtraLight',
  'editor.weight300': 'Light',
  'editor.weight400': 'Regular',
  'editor.weight500': 'Medium',
  'editor.weight600': 'SemiBold',
  'editor.weight700': 'Bold',
  'editor.weight800': 'ExtraBold',
  'editor.weight900': 'Black',
  'preview.title': 'Generowanie',
  'preview.description': 'Wypełnij dane i zobacz wynik dokładnie taki, jaki zwróci API.',
  'preview.formatImage': 'Obraz',
  'preview.formatVideo': 'Wideo',
  'preview.deviceHint':
    'Wideo powstaje na tym komputerze. Nie zamykaj karty, dopóki się nie skończy.',
  'preview.noFields': 'Szablon nie ma jeszcze warstw.',
  'preview.render': 'Generuj',
  'preview.rendering': 'Generowanie…',
  'preview.empty': 'Tutaj pojawi się wynik',
  'preview.openPdf': 'Otwórz PDF',
  'apiDialog.title': 'Generowanie przez API',
  'apiDialog.description': 'Warstwy tego szablonu i gotowe przykłady zapytań',
  'apiDialog.reference': 'Pełna dokumentacja API',
  'apiDialog.layer': 'Warstwa',
  'apiDialog.type': 'Typ',
  'apiDialog.properties': 'Właściwości',
  'apiDialog.hint':
    'Utwórz klucz API w sekcji „API i klucze”. Zamiast obiektu możesz przekazać ciąg znaków: "title": "Tekst" lub "photo": "https://…".',
  'resize.title': 'Kopia w innym rozmiarze',
  'resize.description': 'Tworzymy kopię i dopasowujemy warstwy do nowego rozmiaru',
  'resize.preset': 'Gotowe rozmiary',
  'resize.choosePreset': 'Wybierz rozmiar…',
  'resize.hint':
    'Szablony w różnych rozmiarach z takimi samymi nazwami warstw można wygenerować w jednym uruchomieniu automatyzacji.',
  'resize.limitHint': 'Twój plan pozwala na maksymalnie {n} szablonów.',
  'resize.createCopy': 'Utwórz kopię',
  'resize.created': 'Kopia utworzona',
  'automations.description':
    'Masowe generowanie: dane × szablony → pliki w ZIP, Google Drive, S3 lub webhooku',
  'automations.new': 'Nowa automatyzacja',
  'automations.emptyTitle': 'Brak automatyzacji',
  'automations.emptyText':
    'Prześlij plik CSV lub połącz arkusz Google, wybierz szablony i otrzymaj setki kreacji jednym kliknięciem lub według harmonogramu.',
  'automations.disabled': 'Wyłączona',
  'automations.neverRun': 'Nigdy nie uruchomiono',
  'automations.runNow': 'Uruchom teraz',
  'automations.howTitle': 'Jak to działa',
  'automations.how1': 'Wybierz jeden lub więcej szablonów (np. kwadrat, relację i baner 728×90).',
  'automations.how2': 'Podłącz dane: CSV, arkusz Google, URL do JSON/CSV lub wiersze przez API.',
  'automations.how3':
    'Przypisz kolumny do warstw — kolumny nazwane tak jak warstwy są przypisywane automatycznie.',
  'automations.how4':
    'Wybierz formaty i miejsca docelowe. Uruchamiaj ręcznie, według harmonogramu lub z API.',
  'automations.source.table': 'Tabela / CSV',
  'automations.source.google_sheets': 'Arkusz Google',
  'automations.source.url': 'URL (CSV/JSON/XML)',
  'automations.source.api': 'Wiersze przez API',
  'automation.namePlaceholder': 'Nazwa automatyzacji, np. „Karty produktów”',
  'automation.enabled': 'Włączona',
  'automation.fold': 'Zwiń',
  'automation.unfold': 'Rozwiń',
  'automation.pickTemplates': 'Wybierz szablony ({n})',
  'automation.changeTemplates': 'Zmień wybór',
  'automation.searchTemplates': 'Szukaj szablonu',
  'automation.pickDone': 'Gotowe — dalej dane',
  'automation.sumTemplates': 'Wybrano: {n}',
  'automation.sumNoTemplates': 'Nie wybrano szablonów',
  'automation.sumRows': 'wierszy: {n}',
  'automation.sumAuto': 'według nazw warstw',
  'automation.sumRules': 'reguł: {n}',
  'automation.sumWebhook': 'Webhook',
  'automation.sumManual': 'Ręcznie lub przez API',
  'automation.step1': 'Szablony',
  'automation.step1Hint':
    'Każdy wiersz danych jest generowany z każdym wybranym szablonem. Wybierz zestaw, aby dodać wszystkie jego rozmiary.',
  'automation.noTemplates': 'Najpierw utwórz szablon.',
  'automation.step2': 'Dane',
  'automation.step2Hint': 'Jeden wiersz = jeden zestaw kreacji',
  'automation.uploadCsv': 'Prześlij CSV',
  'automation.csvLoaded': 'Wczytano wiersze: {n}',
  'automation.columnsFromLayers': 'Kolumny z warstw',
  'automation.addColumn': 'Kolumna',
  'automation.addRow': 'Wiersz',
  'automation.rowsCount': 'Wiersze: {n}',
  'automation.rowsHidden': 'Ukryte wiersze: {n} — zostaną jednak wygenerowane.',
  'automation.tableHint':
    'Kolumna nazwana jak warstwa (title) ustawia jej główną wartość; „warstwa.właściwość” (title.color) ustawia właściwość. Puste komórki zachowują wartość z szablonu.',
  'automation.sheetUrl': 'Link do arkusza Google',
  'automation.sheetHint':
    'Arkusz udostępniony przez link działa bez łączenia konta. Pierwszy wiersz musi zawierać nagłówki.',
  'automation.googleAccount': 'Konto Google',
  'automation.publicSheet': 'Link publiczny (bez konta)',
  'automation.sheetName': 'Arkusz',
  'automation.firstSheet': 'pierwszy arkusz',
  'automation.testSource': 'Sprawdź i pokaż dane',
  'automation.sourceOk': 'Wczytano wiersze: {n}, kolumny: {c}',
  'automation.urlHint': 'Pobierany przy każdym uruchomieniu — świetny do feedów produktowych',
  'automation.xmlHint':
    'Feedy Google Merchant i Meta (RSS/Atom), YML dla Rozetki i Prom albo dowolny XML. Każdy produkt dostaje kolumny title, price, old_price, discount, currency, image, link, brand, category — nazwij tak warstwy, a wypełnią się same.',
  'automation.onlyChanged': 'Tylko nowe i zmienione wiersze',
  'automation.onlyChangedHint':
    'Uruchomienie renderuje tylko to, co jest nowe lub zmienione od poprzedniego (cena, zdjęcie, nazwa). Zmiana szablonu, mapowania lub formatu renderuje wszystko od nowa. Idealne do codziennego feedu: nie zużywa generacji na te same banery.',
  'automation.keyColumn': 'Kolumna identyfikatora',
  'automation.keyColumnHint':
    'Po niej wiersz jest rozpoznawany między uruchomieniami — zwykle id lub SKU',
  'automation.keyWholeRow': '— cały wiersz —',
  'automation.unchangedShort': 'bez zmian: {n}',
  'batch.unchanged': 'Pominięto wierszy bez zmian: {n}',
  'batch.nothingChanged':
    'Od poprzedniego uruchomienia nic się nie zmieniło ({n} wierszy) — nie zużyto generacji.',
  'err.xmlEntities': 'XML z deklaracjami encji (<!ENTITY>) nie jest obsługiwany',
  'err.xmlParse': 'Nie udało się odczytać XML: {detail}',
  'err.feedEmpty': 'W feedzie XML nie znaleziono produktów',
  'automation.format': 'Format',
  'automation.apiHint':
    'Wiersze są przesyłane w treści zapytania — wygodne dla CRM, n8n, Make i Zapier.',
  'automation.step3': 'Mapowanie pól',
  'automation.step3Hint': 'Co trafia do każdej warstwy',
  'automation.autoMap': 'Mapuj automatycznie po nazwie',
  'automation.autoMapHint': 'Kolumny zgodne z nazwami warstw są przypisywane automatycznie',
  'automation.selectTemplatesFirst': 'Wybierz szablony, aby zobaczyć ich warstwy.',
  'automation.templatesLoadFailed': 'Nie udało się wczytać pól szablonów.',
  'automation.noFieldsInTemplates': 'Wybrane szablony nie mają warstw do wypełnienia.',
  'automation.value': 'Wartość',
  'automation.sample': 'Przykład (wiersz 1)',
  'automation.inTemplates': 'w {n} z {total}',
  'automation.auto': 'Auto: kolumna {column}',
  'automation.keepTemplate': 'Zachowaj wartość z szablonu',
  'automation.column': 'Kolumna',
  'automation.static': 'Stała wartość',
  'automation.extraRules': 'Dodatkowe reguły',
  'automation.extraRulesHint': 'Np. kolor plakietki z kolumny „color” lub stały kolor tekstu.',
  'automation.addRule': 'Dodaj regułę',
  'automation.previewFirstRow': 'Podgląd pierwszego wiersza',
  'automation.livePreview': 'Podgląd na żywo',
  'automation.prevRow': 'Poprzedni wiersz',
  'automation.nextRow': 'Następny wiersz',
  'automation.rowN': 'wiersz {n} z {total}',
  'automation.livePreviewHint':
    'Najedź na warstwę w tabeli, aby ją tu podświetlić. Kliknij element projektu, aby znaleźć jego wiersz.',
  'automation.livePreviewMedia':
    'Obrazy z biblioteki mediów ({layers}) zostaną wstawione podczas generowania',
  'automation.livePreviewFailed': 'Wartość nie pasuje, warstwa zostanie jak w szablonie: {layers}',
  'automation.lockedLayer': 'Zablokowana w edytorze: automatyzacja jej nie zmienia',
  'automation.step4': 'Wynik',
  'automation.formats': 'Formaty',
  'automation.scale': 'Skala',
  'automation.scaleCapped':
    'Duże szablony wyjdą mniejsze: {list}. Obraz ma najwyżej {side} px na bok i {mpx} Mpx.',
  'automation.scaleNotUsed':
    'PDF jest wektorowy, a wideo ma rozmiar szablonu: skala nie ma znaczenia.',
  'automation.quality': 'Jakość JPG/WEBP',
  'automation.filename': 'Nazwa pliku',
  'automation.filenameHint':
    'Zmienne: {{template}}, {{index}}, {{date}}, {{format}}, {{row.column}}',
  'automation.folders': 'Foldery na pliki',
  'automation.foldersHint':
    'Dla ZIP, Google Drive i S3. Wybierz po kolei, jak układać pliki: pierwszy to folder zewnętrzny. Bez wyboru wszystkie pliki leżą razem.',
  'automation.folderExampleTemplate': 'Szablon',
  'automation.folderBy.template': 'Wg szablonu',
  'automation.folderBy.size': 'Wg rozmiaru',
  'automation.folderBy.format': 'Wg formatu',
  'automation.folderBy.column': 'Wg kolumny',
  'automation.step5': 'Miejsca docelowe',
  'automation.step5Hint': 'Wybierz jedno lub więcej',
  'automation.destZip': 'Archiwum ZIP do pobrania',
  'automation.connectGoogle': 'Połącz Google',
  'automation.connectS3': 'Połącz S3',
  'automation.folderName': 'Folder',
  'automation.subfolderPerRun': 'Podfolder dla każdego uruchomienia',
  'automation.step6': 'Harmonogram',
  'automation.step6Hint': 'Np. pobieraj feed każdego ranka i odświeżaj kreacje',
  'automation.scheduleOn': 'Uruchamiaj według harmonogramu',
  'automation.frequency': 'Częstotliwość',
  'automation.timezone': 'Strefa czasowa',
  'automation.nextRuns': 'Najbliższe uruchomienia',
  'automation.invalidCron': 'Nieprawidłowe wyrażenie cron',
  'automation.cron.hourly': 'Co godzinę',
  'automation.cron.daily': 'Codziennie o 9:00',
  'automation.cron.weekly': 'W poniedziałki o 9:00',
  'automation.cron.monthly': 'Co miesiąc, 1. dnia o 9:00',
  'automation.cron.custom': 'Własny',
  'automation.runs': 'Historia uruchomień',
  'automation.estimate': 'Liczba plików do wygenerowania: {n}',
  'automation.estimateUnknown': 'Liczba będzie znana po wczytaniu danych',
  'automation.overLimit': 'ponad limit Twojego planu ({n} na uruchomienie)',
  'automation.saveAndRun': 'Zapisz i uruchom',
  'automation.saved': 'Automatyzacja zapisana',
  'automation.deleteTitle': 'Usunąć automatyzację?',
  'automation.deleteText': 'Historia uruchomień i wygenerowane pliki zostaną zachowane.',
  'destination.zip': 'Archiwum ZIP',
  'destination.google_drive': 'Google Drive',
  'destination.s3': 'Amazon S3 / zgodne',
  'destination.webhook': 'Webhook',
  'batch.title': 'Uruchomienie',
  'batch.status.pending': 'Przygotowanie',
  'batch.status.processing': 'Generowanie',
  'batch.status.done': 'Gotowe',
  'batch.status.partial': 'Częściowo',
  'batch.status.failed': 'Błąd',
  'batch.trigger.manual': 'ręcznie',
  'batch.trigger.schedule': 'wg harmonogramu',
  'batch.trigger.api': 'przez API',
  'batch.total': 'łącznie',
  'batch.done': 'gotowe',
  'batch.failed': 'błędy',
  'batch.finished': 'Zakończono',
  'batch.downloadZip': 'Pobierz ZIP',
  'batch.deliveries': 'Dostarczenie',
  'batch.files': 'Pliki: {n}',
  'batch.showingFirst':
    'Wyświetlanych jest pierwszych 200 plików — wszystkie pliki są w archiwum ZIP.',
  'renders.description': 'Wszystkie wygenerowane obrazy i pliki PDF',
  'renders.tabRenders': 'Pliki',
  'renders.tabBatches': 'Partie',
  'renders.allStatuses': 'Wszystkie statusy',
  'renders.allSources': 'Wszystkie źródła',
  'renders.file': 'Plik',
  'renders.status': 'Status',
  'renders.source': 'Źródło',
  'renders.size': 'Rozmiar',
  'renders.created': 'Utworzono',
  'renders.duration': 'Czas trwania',
  'renders.modifications': 'Modyfikacje',
  'renders.emptyTitle': 'Brak wygenerowanych obrazów',
  'renders.emptyText': 'Uruchom automatyzację lub wywołaj API — wyniki pojawią się tutaj.',
  'renders.noBatches': 'Brak partii',
  'renders.loadMore': 'Wczytaj więcej',
  'renders.sources.api': 'API',
  'renders.sources.editor': 'Edytor',
  'renders.sources.automation': 'Automatyzacja',
  'renders.sources.url': 'Podpisany URL',
  'renders.statuses.queued': 'W kolejce',
  'renders.statuses.rendering': 'Generowanie',
  'renders.statuses.done': 'Gotowe',
  'renders.statuses.failed': 'Błąd',
  'assets.description': 'Zdjęcia, logotypy i ikony do Twoich szablonów',
  'assets.storage': 'Miejsce: {used} z {limit}',
  'assets.drop':
    'Przeciągnij zdjęcia lub wideo albo kliknij, aby wybrać (PNG, JPG, WEBP, SVG, GIF, MP4, MOV, WEBM)',
  'assets.importUrl': 'Importuj z URL',
  'assets.emptyTitle': 'Twoja biblioteka mediów jest pusta',
  'assets.emptyText': 'Prześlij logotypy i zdjęcia, aby używać ich w szablonach.',
  'assets.copyUrl': 'Kopiuj URL',
  'assets.deleteTitle': 'Usunąć plik?',
  'assets.deleteText': 'Szablony, które go używają, pokażą puste miejsce.',
  'fonts.description':
    'Włącz potrzebne czcionki i prześlij czcionki marki — będą dostępne w edytorze i przy generowaniu',
  'fonts.custom': 'Własne czcionki',
  'fonts.builtin': 'Wbudowane',
  'fonts.customBadge': 'własna',
  'fonts.customLocked': 'Własne czcionki w planach Pro i Business',
  'fonts.filterAll': 'Wszystkie',
  'fonts.filterEnabled': 'Włączone',
  'fonts.filterCyrillic': 'Cyrylica',
  'fonts.sampleText': 'Pchnąć w tę łódź jeża lub ośm skrzyń fig',
  'fonts.cyrillic': 'Cyrylica',
  'fonts.cyrShort': 'Cyr',
  'fonts.sample': 'Tekst podglądu',
  'fonts.enabledCount': 'Włączone: {n} z {total}',
  'fonts.disableHint':
    'Wyłączone czcionki są ukryte w edytorze, a istniejące szablony nadal generują się poprawnie.',
  'fonts.files': 'Przesłane pliki',
  'fonts.uploadTitle': 'Prześlij czcionkę',
  'fonts.uploadHint':
    'TTF, OTF, WOFF lub WOFF2. Każdą grubość prześlij jako osobny plik z tą samą rodziną.',
  'fonts.dropFont': 'Upuść plik czcionki lub kliknij',
  'fonts.family': 'Rodzina',
  'fonts.familyHint': 'Zostaw puste, aby odczytać ją z pliku',
  'fonts.weight': 'Grubość',
  'fonts.style': 'Styl',
  'fonts.auto': 'Wykryj automatycznie',
  'fonts.upload': 'Prześlij',
  'fonts.uploaded': 'Czcionka {family} {weight} przesłana',
  'fonts.deleteTitle': 'Usunąć plik czcionki?',
  'fonts.deleteText': 'Szablony używające tej grubości przełączą się na inną czcionkę.',
  'api.description': 'Podłącz generowanie do swojej strony, CRM lub skryptów',
  'api.keys': 'Klucze API',
  'api.keysHint':
    'Klucz daje dostęp do wszystkich szablonów w przestrzeni roboczej. Przechowuj go na swoim serwerze.',
  'api.createKey': 'Utwórz klucz',
  'api.adminOnly': 'Tylko administratorzy mogą zarządzać kluczami.',
  'api.noKeys': 'Brak kluczy',
  'api.created': 'utworzony',
  'api.lastUsed': 'użyty',
  'api.neverUsed': 'nigdy nieużyty',
  'api.revoke': 'Unieważnij',
  'api.revokeTitle': 'Unieważnić klucz?',
  'api.revokeText': 'Zapytania z kluczem „{name}” natychmiast przestaną działać.',
  'api.keyCreated': 'Klucz utworzony',
  'api.copyNow': 'Skopiuj klucz teraz — nie pokażemy go ponownie.',
  'api.keyNameHint': 'Np. gdzie jest używany',
  'api.quickstart': 'Szybki start',
  'api.reference': 'Dokumentacja',
  'api.tabSingle': 'Pojedynczy obraz',
  'api.tabBatch': 'Partia',
  'api.tabAsync': 'Asynchronicznie',
  'api.layersHelp':
    'zmiany według nazwy warstwy: ciąg znaków ustawia główną wartość, obiekt ustawia właściwości, null ukrywa warstwę.',
  'api.scaleHelp': '2 dla ekranów retina.',
  'api.webhookHelp': 'powiadomimy Cię, gdy plik będzie gotowy (podpis HMAC).',
  'api.signedTitle': 'Podpisane URL-e obrazów',
  'api.signedHint':
    'Obraz generuje się przy pierwszym żądaniu i jest zapisywany w pamięci podręcznej. Idealne do e-maili, Open Graph i landing page’y — bez kodu po stronie serwera.',
  'api.generateUrl': 'Wygeneruj URL',
  'api.urlAppearsHere': 'Tutaj pojawi się URL i podgląd',
  'api.signingSecret': 'Sekret podpisu',
  'api.signingSecretHint':
    'Służy do podpisywania URL-i i webhooków. Podpisuj URL-e po swojej stronie — zobacz przykład.',
  'api.reveal': 'Pokaż',
  'api.rotate': 'Zmień sekret',
  'api.rotateTitle': 'Zmienić sekret?',
  'api.rotateText':
    'Wszystkie wcześniej wydane podpisane URL-e przestaną działać, a webhooki będą używać nowego sekretu.',
  'integrations.description': 'Skąd pochodzą dane i dokąd trafiają pliki',
  'integrations.locked': 'Integracje są dostępne od planu Starter.',
  'integrations.googleHint': 'Odczyt arkuszy Google i przesyłanie plików na Google Drive',
  'integrations.googleNotConfigured':
    'Google OAuth nie jest skonfigurowany na serwerze (GOOGLE_CLIENT_ID / GOOGLE_CLIENT_SECRET). Publiczne arkusze działają bez niego.',
  'integrations.connectGoogle': 'Połącz konto Google',
  'integrations.googleConnected': 'Google połączony',
  'integrations.googleReconnected': 'To konto Google było już połączone — dostęp odnowiono',
  'integrations.googleFailed': 'Nie udało się połączyć z Google',
  'integrations.s3Short': 'AWS, Cloudflare R2, MinIO, Wasabi, DigitalOcean…',
  'integrations.addBucket': 'Dodaj bucket',
  'integrations.s3Title': 'Połącz S3',
  'integrations.s3Hint': 'Sprawdzamy dostęp, zapisując plik kontrolny .bannermatic-check',
  'integrations.endpointHint': 'Dla dostawców innych niż AWS',
  'integrations.publicBase': 'Publiczny bazowy URL (opcjonalnie)',
  'integrations.testAndSave': 'Sprawdź i zapisz',
  'integrations.connected': 'Połączono',
  'integrations.webhooks': 'Webhooki',
  'integrations.webhooksHint':
    'Powiadomienia POST o gotowych obrazach i partiach, podpisane HMAC-SHA256',
  'integrations.defaultWebhook': 'Domyślny webhook dla automatyzacji',
  'integrations.defaultWebhookHint': 'Otrzymuje batch.completed po każdym uruchomieniu',
  'integrations.testWebhook': 'Testowy webhook',
  'integrations.send': 'Wyślij',
  'integrations.testSent': 'Zdarzenie testowe dodane do kolejki',
  'integrations.verifyTitle': 'Weryfikacja podpisu',
  'integrations.recentDeliveries': 'Ostatnie dostarczenia',
  'integrations.removeTitle': 'Usunąć integrację?',
  'integrations.removeText': 'Automatyzacje, które jej używają, nie dostarczą plików.',
  'settings.tabGeneral': 'Ogólne',
  'settings.tabMembers': 'Zespół',
  'settings.tabBilling': 'Płatności',
  'settings.tabProfile': 'Profil',
  'settings.workspace': 'Przestrzeń robocza',
  'settings.dangerZone': 'Strefa zagrożenia',
  'settings.deleteWorkspace': 'Usuń przestrzeń roboczą',
  'settings.deleteWorkspaceText':
    'Wszystkie szablony, pliki, klucze i historia generowania zostaną usunięte. Tej operacji nie można cofnąć.',
  'settings.deleteWorkspaceConfirm': 'Na pewno usunąć „{name}” wraz ze wszystkimi danymi?',
  'settings.lastWorkspace': 'To Twoja jedyna przestrzeń robocza, więc nie można jej usunąć.',
  'workspace.noneTitle': 'Nie masz jeszcze przestrzeni roboczej',
  'workspace.noneText':
    'Utwórz przestrzeń roboczą, aby pracować z szablonami, lub poproś członków zespołu o zaproszenie do ich przestrzeni.',
  'settings.invite': 'Zaproś członków zespołu',
  'settings.inviteHint': 'Wyślemy e-mailem link z zaproszeniem.',
  'settings.seats': 'Miejsca: {used} z {limit}.',
  'settings.sendInvite': 'Zaproś',
  'settings.invited': 'Zaproszenie wysłane',
  'settings.inviteLink': 'Link',
  'settings.you': 'Ty',
  'settings.remove': 'Usuń z zespołu',
  'settings.pendingInvites': 'Oczekujące zaproszenia',
  'settings.expires': 'wygasa',
  'settings.rolesTitle': 'Role',
  'settings.roleOwner': 'wszystko, łącznie z płatnościami i usuwaniem',
  'settings.roleAdmin': 'zespół, klucze API, integracje',
  'settings.roleEditor': 'szablony, media, czcionki, automatyzacje i generowanie',
  'settings.roleViewer': 'podgląd szablonów i wyników',
  'settings.language': 'Język interfejsu',
  'settings.changePassword': 'Zmień hasło',
  'settings.currentPassword': 'Obecne hasło',
  'settings.passwordChanged': 'Hasło zmienione',
  'billing.currentPlan': 'Obecny plan',
  'billing.renewsOn': 'Odnawia się',
  'billing.endsOn': 'Kończy się',
  'billing.manage': 'Zarządzaj subskrypcją',
  'billing.rendersPeriod': 'Generowania w tym okresie',
  'billing.storage': 'Miejsce',
  'billing.plans': 'Plany',
  'billing.monthly': 'Miesięcznie',
  'billing.yearly': 'Rocznie (−{n}%)',
  'billing.mo': 'mies.',
  'billing.popular': 'Popularny',
  'billing.current': 'Obecny plan',
  'billing.choose': 'Wybierz',
  'billing.thanks': 'Dziękujemy! Twoja subskrypcja aktywuje się w ciągu minuty.',
  'billing.switched': 'Plan zmieniony',
  'billing.devMode':
    'Płatności nie są skonfigurowane: tryb deweloperski pozwala zmieniać plany bez płacenia. Na produkcji podłącz Lemon Squeezy (LEMONSQUEEZY_API_KEY) lub Stripe (STRIPE_SECRET_KEY).',
  'billing.noStripe':
    'Płatności nie są skonfigurowane na tym serwerze. Skontaktuj się z administratorem.',
  'billing.fRenders': '{n} generowań / miesiąc',
  'billing.fTemplates': 'Do {n} szablonów',
  'billing.fTemplatesUnlimited': 'Nieograniczona liczba szablonów',
  'billing.fMembers': 'Do {n} członków zespołu',
  'billing.fMembersUnlimited': 'Nieograniczona liczba członków zespołu',
  'billing.fAutomations': 'Do {n} automatyzacji',
  'billing.fAutomationsUnlimited': 'Nieograniczona liczba automatyzacji',
  'billing.fBatch': 'Do {n} plików na uruchomienie',
  'billing.fFonts': 'Własne czcionki',
  'billing.fIntegrations': 'Google Drive, Sheets, S3',
  'billing.fSigned': 'Podpisane URL-e obrazów',
  'billing.fSchedule': 'Automatyzacje według harmonogramu',
  'billing.fNoWatermark': 'Bez znaku wodnego',
  'landing.navFeatures': 'Funkcje',
  'landing.navSpreadsheets': 'Arkusze',
  'landing.navPricing': 'Cennik',
  'landing.navDocs': 'Dokumentacja API',
  'landing.login': 'Zaloguj się',
  'landing.startFree': 'Zacznij za darmo',
  'landing.openApp': 'Otwórz aplikację',
  'landing.badge': 'Szablony · Arkusze · API',
  'landing.title': 'Setki banerów z jednego szablonu — w kilka minut',
  'landing.subtitle':
    'Zaprojektuj szablon w edytorze wizualnym, a potem dostarczaj teksty, zdjęcia, ceny i logotypy przez API, Google Sheets lub CSV. Otrzymuj PNG, JPG, WEBP i PDF.',
  'landing.ctaPrimary': 'Utwórz swój pierwszy szablon',
  'landing.ctaSecondary': 'Zobacz API',
  'landing.noCard': 'Plan darmowy na zawsze. Bez karty płatniczej.',
  'landing.demoRows': 'Wiersze: {n}',
  'landing.uc1': 'Karty produktów na marketplace’y',
  'landing.uc2': 'Reklamy displayowe w każdym rozmiarze',
  'landing.uc3': 'Posty i relacje w social mediach',
  'landing.uc4': 'Obrazy OG i banery do e-maili',
  'landing.demo1Title': 'Letnia wyprzedaż',
  'landing.demo1Subtitle': 'Rabaty na całą kolekcję',
  'landing.demo2Title': 'Nowa kolekcja butów do biegania',
  'landing.demo2Subtitle': 'Lekkie, szybkie, przewiewne',
  'landing.demo3Title': 'Black Friday',
  'landing.demo3Subtitle': 'Tylko 3 dni — pospiesz się',
  'landing.demo4Title': 'Karty podarunkowe',
  'landing.demo4Subtitle': 'Idealny prezent na święta',
  'landing.demoFrom': 'od {price}',
  'landing.uc5': 'Certyfikaty i cenniki w PDF',
  'landing.featuresTitle': 'Wszystko do automatyzacji kreacji',
  'landing.featuresSubtitle':
    'Projektant tworzy szablon raz, a kreacje składają się same z API, arkuszy i feedów.',
  'landing.f1Title': 'Edytor wizualny',
  'landing.f1Text':
    'Warstwy, tekst, zdjęcia, logotypy, kształty, kody QR, gradienty, cienie, inteligentne prowadnice i automatyczne dopasowanie tekstu.',
  'landing.f2Title': 'REST API',
  'landing.f2Text':
    'Generowanie synchroniczne i asynchroniczne, partie tysięcy plików, podpisane webhooki i dokumentacja OpenAPI.',
  'landing.f3Title': 'Studio automatyzacji',
  'landing.f3Text':
    'CSV, Google Sheets, feedy produktowe Google Merchant, Meta i YML × wiele szablonów → ZIP, Google Drive, S3 lub webhooki. Według harmonogramu — tylko zmienione produkty.',
  'landing.f4Title': 'Twoje czcionki',
  'landing.f4Text':
    '40 popularnych czcionek z cyrylicą wbudowanych w edytor. Prześlij czcionki marki TTF/OTF/WOFF i ukryj resztę.',
  'landing.f5Title': 'Obrazy i wideo',
  'landing.f5Text':
    'Przezroczysty PNG, JPG, WEBP, wektorowy PDF do druku, retina do 3x — oraz wideo MP4, WebM i GIF na Reels, TikTok i Shorts.',
  'landing.f6Title': 'Co do piksela',
  'landing.f6Text':
    'Edytor i serwer używają tego samego silnika renderującego — widzisz dokładnie to, co dostaniesz.',
  'landing.howTitle': 'Jak to działa',
  'landing.step1Title': 'Zaprojektuj szablon',
  'landing.step1Text': 'Ułóż warstwy w edytorze i nazwij te dynamiczne: title, photo, price.',
  'landing.step2Title': 'Podłącz dane',
  'landing.step2Text': 'Wyślij JSON do API, prześlij CSV lub podłącz arkusz Google.',
  'landing.step3Title': 'Odbierz pliki',
  'landing.step3Text':
    'Pliki trafiają do Ciebie jako linki, ZIP, na Drive, do S3 lub na Twój webhook.',
  'landing.apiTitle': 'API, które łatwo zintegrować',
  'landing.apiText':
    'Jedno zapytanie — jeden obraz. Albo tysiąc w partii. Działa z każdego języka, n8n, Make i Zapier.',
  'landing.api1': 'Zmieniaj teksty, zdjęcia, kolory, położenie i widoczność po nazwie warstwy',
  'landing.api2': 'Czekaj na wynik w odpowiedzi lub odbierz webhook',
  'landing.api3': 'Podpisane URL-e — obraz z adresu URL bez kodu serwerowego',
  'landing.api4': 'Limity, klucze i logi dostarczeń — pełna przejrzystość',
  'landing.apiCalloutTitle': 'Silnik automatycznego renderowania',
  'landing.apiCalloutText':
    'Przekazuj parametry warstw przez API, webhooki lub arkusze — szybkie równoległe renderowanie.',
  'landing.pricingTitle': 'Prosty cennik',
  'landing.pricingSubtitle': 'Płacisz za liczbę generowań. Edytor i API są w każdym planie.',
  'landing.tryPlan': 'Wybierz {plan}',
  'landing.watermark': 'Ze znakiem wodnym',
  'landing.faqTitle': 'FAQ',
  'landing.q1': 'Czym to się różni od zwykłego narzędzia do projektowania?',
  'landing.a1':
    'Zwykłe narzędzie do projektowania służy do pracy ręcznej. Bannermatic służy do pracy na dużą skalę: jeden szablon automatycznie zamienia się w setki wariantów dzięki API, arkuszom i harmonogramom.',
  'landing.q2': 'Czy mogę przesuwać elementy, a nie tylko zmieniać tekst?',
  'landing.a2':
    'Tak. Dla każdej warstwy możesz przekazać x, y, width, height, rotation i opacity, zmienić jej kolor lub ją ukryć (hide: true lub null), np. {"logo": {"x": 40, "y": 860, "width": 180}}. Warstwy w stosie są rozmieszczane przez auto layout — tam zmieniasz ich rozmiar oraz kierunek i odstęp stosu, a nie współrzędne.',
  'landing.q3': 'A co z długim tekstem?',
  'landing.a3':
    'Włącz automatyczne dopasowanie: czcionka zmniejszy się, aby tekst się zmieścił, lub ogranicz liczbę wierszy z wielokropkiem.',
  'landing.metaTitle': 'Bannermatic — Automatyczne generowanie banerów przez API i arkusze',
  'landing.metaDescription':
    'Wizualny edytor szablonów i REST API do masowego generowania banerów, kart produktów na marketplace, grafik do social media i PDF z Google Sheets i CSV.',
  'landing.q4': 'Czy cyrylica i własne czcionki są obsługiwane?',
  'landing.a4':
    'Tak, większość wbudowanych czcionek zawiera cyrylicę, a w płatnych planach możesz przesłać własne TTF/OTF/WOFF.',
  'landing.q5': 'Jak generować banery z Google Sheets bez znajomości kodu?',
  'landing.a5':
    'Połącz Google Sheets lub prześlij plik CSV w Studio Automatyzacji. Kolumny arkusza są mapowane na warstwy szablonu (title, price, photo), a Bannermatic generuje setki gotowych banerów w archiwum ZIP, Google Drive lub S3.',
  'landing.q6': 'Czy usługa nadaje się do kart produktów na platformach marketplace?',
  'landing.a6':
    'Tak, to jeden z głównych scenariuszy. Możesz masowo nakładać plakietki rabatowe, specyfikacje, ceny i logo marek na zdjęcia produktów ze swojego feedu lub katalogu.',
  'landing.finalTitle': 'Przestań robić banery ręcznie',
  'landing.finalText': 'Zbuduj szablon w 10 minut i przekaż rutynę API.',
  'landing.tablesBadge': 'Bez kodowania · Studio arkuszy',
  'landing.tablesTitle': 'Banery z arkuszy bez kodu',
  'landing.tablesSubtitle':
    'Połącz Arkusz Google lub prześlij CSV. Kolumny automatycznie łączą się z warstwami szablonu, generując setki gotowych banerów jednym kliknięciem.',
  'landing.tablesPoint1Title': 'Import z Arkuszy Google i CSV',
  'landing.tablesPoint1Text':
    'Połącz arkusz online lub przeciągnij plik z produktami. Bannermatic natychmiast odczyta strukturę danych.',
  'landing.tablesPoint2Title': 'Wizualne mapowanie kolumn',
  'landing.tablesPoint2Text':
    'Wskaż, która kolumna odpowiada za tytuł, cenę, rabat czy zdjęcie. Inteligentny system automatycznie połączy warstwy.',
  'landing.tablesPoint3Title': 'Generowanie wsadowe i szybki eksport',
  'landing.tablesPoint3Text':
    'Setki banerów generowane są równolegle w kilka sekund. Pobierz archiwum ZIP lub wyślij pliki do chmury.',
  'landing.tablesMascotBubble': 'Dodaj tabelę i gotowe!',
  'landing.tablesCta': 'Otwórz Studio Automatyzacji',
  'landing.tablesMockSync': 'Zsynchronizowano · 450 wierszy',
  'landing.tablesMockBtn': 'Wygeneruj 450 banerów',
  'landing.tablesMockColProduct': 'Produkt',
  'landing.tablesMockColPrice': 'Cena',
  'landing.tablesMockColDiscount': 'Rabat',
  'landing.tablesMockColPhoto': 'Zdjęcie',
  'landing.tablesMockColStatus': 'Status',
  'landing.tablesMockDone': 'Gotowe',
  'automation.autoMapped': 'Dopasowano kolumny: {n}',
  'automation.autoMapNone': 'Nie znaleziono nowych dopasowań kolumn',
  'automation.matchColumns': 'Dopasuj kolumny',
  'automation.mediaHint': 'Komórki z obrazami mogą wskazywać pliki z biblioteki mediów:',
  'media.allFiles': 'Wszystkie pliki',
  'media.noFolder': 'Bez folderu',
  'media.folders': 'Foldery',
  'media.newFolder': 'Nowy folder',
  'media.renameFolder': 'Zmień nazwę folderu',
  'media.renameFile': 'Zmień nazwę pliku',
  'media.rename': 'Zmień nazwę',
  'media.moveTo': 'Przenieś do folderu',
  'media.moved': 'Plik przeniesiony',
  'media.folderPlaceholder': 'np. Drużyny',
  'media.foldersHint':
    'Uporządkuj logo i tła w folderach — „Drużyny”, „Ligi”… Przeciągnij plik na folder, aby go przenieść.',
  'media.dropInto': 'Upuść pliki tutaj, a trafią do folderu „{folder}”',
  'media.search': 'Szukaj po nazwie pliku lub folderu',
  'media.nothingFound': 'Nic nie znaleziono',
  'media.copyRef': 'Kopiuj odwołanie do automatyzacji',
  'media.refCopied': 'Skopiowano — wklej do komórki tabeli lub API',
  'media.refHint': 'W tabelach automatyzacji i API wskaż plik tak:',
  'media.exampleFolder': 'Drużyny',
  'media.exampleName': 'Arsenal',
  'media.deleteFolderTitle': 'Usunąć folder „{name}”?',
  'media.deleteFolderText':
    'Pliki zostaną zachowane i trafią do „Bez folderu”. Odwołania media:Folder/… przestaną je znajdować.',
  'media.allFolders': 'Wszystkie foldery',
  'media.pick': 'Wybierz z biblioteki mediów',
  'err.folderExists': 'Folder „{name}” już istnieje',
  'err.nameRequired': 'Wpisz nazwę',
  'err.mediaNotFound': 'Warstwa „{layer}”: „{ref}” nie ma w bibliotece mediów',
  'qr.style': 'Styl kodu QR',
  'qr.paid':
    'Zaokrąglone punkty, styl narożników, własny kolor i logo w środku — w planach Pro i Business.',
  'qr.upgrade': 'Zmień plan',
  'qr.dots': 'Punkty',
  'qr.eyes': 'Narożniki',
  'qr.eyeColor': 'Kolor narożników',
  'qr.logo': 'Logo w środku',
  'qr.logoHint': 'Dostępne w Pro i Business',
  'qr.logoSize': 'Rozmiar logo',
  'qr.logoNote':
    'Z logo kod używa najwyższej korekcji błędów (H) — sprawdź skanowanie na podglądzie.',
  'qr.dot.square': 'Kwadraty',
  'qr.dot.rounded': 'Zaokrąglone',
  'qr.dot.dots': 'Kropki',
  'qr.eye.square': 'Kwadrat',
  'qr.eye.rounded': 'Zaokrąglony',
  'qr.eye.circle': 'Koło',
  'billing.fQrStyles': 'Stylowe kody QR z logo',
  'retention.label': 'Przechowywany',
  'retention.until': 'do {date}',
  'retention.keptUntil': 'Pliki są przechowywane do {date}',
  'retention.batchExpired': 'Okres przechowywania minął — pliki zostały usunięte',
  'retention.renderExpired': 'Plik usunięto po upływie okresu przechowywania',
  'google.spreadsheet': 'Arkusz',
  'google.chooseSpreadsheet': 'Wybierz arkusz',
  'google.noSpreadsheets': 'Brak arkuszy — wybierz w Google Drive lub wklej link',
  'google.listHint':
    'Google pokazuje aplikacjom tylko arkusze wybrane przez „Google Drive” lub już używane w automatyzacjach.',
  'google.refresh': 'Odśwież listę',
  'google.fromDrive': 'Google Drive',
  'google.orLink': '…lub link do arkusza',
  'google.linkedSheet': 'Arkusz z linku',
  'google.noAccess': 'To konto Google nie może otworzyć arkusza — sprawdź link i udostępnianie.',
  'google.noAccessPick':
    'Bannermatic widzi tylko arkusze wybrane w Google Drive. Otwórz ten arkusz tam raz — dostęp będzie tylko do niego.',
  'google.grantAccess': 'Daj dostęp do tego arkusza',
  'common.loading': 'Ładowanie…',
  'common.retry': 'Spróbuj ponownie',
  'err.pickerOwnerOnly':
    'Tylko osoba, która połączyła konto Google (lub administrator), może przeglądać Dysk',
  'err.pickerDisabled': 'Wybór z Google Drive nie jest skonfigurowany na serwerze',
  'common.close': 'Zamknij',
  'common.menu': 'Menu',
  'history.title': 'Historia wersji',
  'history.paid': 'Historia zmian szablonu z przywracaniem dowolnej wersji — w planie Business.',
  'history.restore': 'Przywróć tę wersję',
  'history.restored': 'Przywrócono wersję z {time}',
  'history.empty': 'Wersje pojawią się po pierwszych zmianach.',
  'history.current': 'Bieżąca',
  'history.restoreOf': 'Przywrócono wersję {version}',
  'history.initial': 'Wersja początkowa',
  'history.edited': 'Zmiany',
  'history.hint':
    'Zmiany jednej osoby w ciągu ~10 minut to jedna wersja. Przechowywane 180 dni, do 200 na szablon.',
  'comments.title': 'Komentarze',
  'comments.paid': 'Komentarze do szablonów do uzgadniania w zespole — w planie Business.',
  'comments.empty': 'Brak komentarzy. Zaznacz warstwę, aby przypiąć do niej uwagę.',
  'comments.resolve': 'Oznacz jako rozwiązany',
  'comments.reopen': 'Otwórz ponownie',
  'comments.showResolved': 'Pokaż rozwiązane ({n})',
  'comments.hideResolved': 'Ukryj rozwiązane',
  'comments.placeholder': 'Uwaga lub pytanie… (Ctrl+Enter — wyślij)',
  'comments.pin': 'Do warstwy „{layer}”',
  'comments.send': 'Wyślij',
  'review.title': 'Akceptacja',
  'review.status.draft': 'Szkic',
  'review.status.in_review': 'Do akceptacji',
  'review.status.changes_requested': 'Do poprawy',
  'review.status.approved': 'Zaakceptowany',
  'review.hint.approved': 'Zaakceptowany {time}. Zmiany projektu przywrócą go do szkicu.',
  'review.hint.inReview': 'Czeka na decyzję właściciela lub administratora.',
  'review.hint.changes':
    'Potrzebne poprawki — uwagi w komentarzach poniżej. Po poprawkach wyślij ponownie.',
  'review.hint.edited': 'Zmieniony po akceptacji.',
  'review.hint.editedRequired':
    'Zmieniony po akceptacji. API, automatyzacje i linki rysują zaakceptowaną wersję, dopóki nowa nie zostanie zaakceptowana.',
  'review.hint.draft': 'Gdy projekt będzie gotowy, wyślij go do akceptacji.',
  'review.hint.draftRequired':
    'Jeszcze niezaakceptowany: API, automatyzacje i linki go nie renderują (podglądy działają).',
  'review.notePlaceholder': 'Co poprawić? Uwaga trafi do komentarzy',
  'review.sendBack': 'Odeślij do poprawy',
  'review.approve': 'Akceptuj',
  'review.requestChanges': 'Poproś o zmiany',
  'review.request': 'Wyślij do akceptacji',
  'review.done.request': 'Wysłano do akceptacji',
  'review.done.approve': 'Szablon zaakceptowany',
  'review.done.changes': 'Odesłano do poprawy',
  'approval.title': 'Wymagaj akceptacji szablonów',
  'approval.text':
    'API, automatyzacje i podpisane linki renderują tylko zaakceptowaną wersję szablonu. Zmiany nie trafią do kampanii i feedów, dopóki nie zostaną zaakceptowane. Podglądy i generowanie w edytorze działają jak dotąd.',
  'approval.on': 'Akceptacja wymagana',
  'approval.off': 'Akceptacja wyłączona',
  'audit.template.review_requested': 'Wysłano do akceptacji:',
  'audit.template.approved': 'Zaakceptowano szablon:',
  'audit.template.changes_requested': 'Odesłano do poprawy:',
  'err.templateNotApproved':
    'Szablon „{name}” nie jest jeszcze zaakceptowany. Zaakceptuj go w edytorze lub wyłącz wymaganą akceptację.',
  'err.reviewAlreadyApproved': 'Ta wersja jest już zaakceptowana',
  'activity.tab': 'Aktywność',
  'activity.paid':
    'Dziennik aktywności — kto co zmienił i uruchomił — w planie Business. Zdarzenia są już zapisywane: po zmianie planu zobaczysz też wcześniejsze.',
  'activity.description': 'Kto co zmienił i uruchomił. Przechowywane 365 dni.',
  'activity.allTypes': 'Wszystkie zdarzenia',
  'activity.empty': 'Brak zdarzeń',
  'activity.more': 'Pokaż więcej',
  'activity.times': '×{n}',
  'activity.apiKey': 'Klucz API',
  'activity.system': 'System',
  'activity.version': 'wersja {n}',
  'activity.renders': 'plików: {n}',
  'activity.trigger.manual': 'ręcznie',
  'activity.trigger.schedule': 'wg harmonogramu',
  'activity.trigger.api': 'przez API',
  'activity.type.template': 'Szablony',
  'activity.type.automation': 'Automatyzacje',
  'activity.type.member': 'Zespół',
  'activity.type.api_key': 'Klucze API',
  'activity.type.integration': 'Integracje',
  'activity.type.asset': 'Media',
  'activity.type.font': 'Czcionki',
  'audit.template.created': 'Utworzono szablon',
  'audit.template.imported': 'Zaimportowano szablon',
  'audit.template.updated': 'Edytowano szablon',
  'audit.template.deleted': 'Usunięto szablon',
  'audit.template.duplicated': 'Skopiowano szablon',
  'audit.template.restored': 'Przywrócono wersję szablonu',
  'audit.comment.added': 'Komentarz do szablonu',
  'audit.automation.created': 'Utworzono automatyzację',
  'audit.automation.updated': 'Edytowano automatyzację',
  'audit.automation.deleted': 'Usunięto automatyzację',
  'audit.automation.run': 'Uruchomiono automatyzację',
  'audit.batch.created': 'Pakiet przez API',
  'audit.member.invited': 'Wysłano zaproszenie do',
  'audit.member.joined': 'Do zespołu dołączył(a)',
  'audit.member.removed': 'Usunięto z zespołu',
  'audit.member.left': 'Opuścił(a) zespół',
  'audit.member.role_changed': 'Zmieniono rolę',
  'audit.invitation.revoked': 'Cofnięto zaproszenie',
  'audit.api_key.created': 'Utworzono klucz API',
  'audit.api_key.revoked': 'Unieważniono klucz API',
  'audit.integration.connected': 'Połączono integrację',
  'audit.integration.updated': 'Ponownie połączono integrację',
  'audit.integration.deleted': 'Usunięto integrację',
  'audit.asset.uploaded': 'Przesłano pliki, ostatni:',
  'audit.asset.deleted': 'Usunięto plik',
  'audit.folder.created': 'Utworzono folder',
  'audit.folder.deleted': 'Usunięto folder',
  'audit.font.uploaded': 'Przesłano czcionkę',
  'audit.font.deleted': 'Usunięto czcionkę',
  'audit.motion_preset.created': 'Utworzono preset animacji',
  'audit.motion_preset.updated': 'Zmieniono preset animacji',
  'audit.motion_preset.deleted': 'Usunięto preset animacji',
  'audit.workspace.updated': 'Zmieniono ustawienia przestrzeni',
  'audit.signing_secret.rotated': 'Zmieniono sekret podpisu',
  'audit.plan.changed': 'Zmieniono plan',
  'err.businessFeature': 'Dostępne w planie Business',
  'err.commentEmpty': 'Napisz komentarz',
  'billing.fHistory': 'Historia wersji, komentarze, akceptacja szablonów, dziennik aktywności',
  'brand.title': 'Brand kit',
  'brand.description':
    'Kolory, czcionki i logo marki ustawiasz raz — szablony się do nich odwołują.',
  'brand.create': 'Utwórz markę',
  'brand.newName': 'Marka {n}',
  'brand.paid':
    'Brand kit w planach Pro (jedna marka) i Business (kilka marek, przełączanie marki klienta w automatyzacjach i API).',
  'brand.emptyTitle': 'Brak marek',
  'brand.emptyText': 'Utwórz markę i ustaw jej kolory, czcionki i logo.',
  'brand.moreOnBusiness': 'Kilka marek (dla agencji i klientów) w planie Business.',
  'brand.default': 'Domyślna',
  'brand.makeDefault': 'Ustaw jako domyślną',
  'brand.saved': 'Zapisano markę — szablony się zaktualizują',
  'brand.colorsTitle': 'Kolory',
  'brand.fontsTitle': 'Czcionki',
  'brand.logosTitle': 'Logo',
  'brand.deleteTitle': 'Usunąć markę „{name}”?',
  'brand.deleteText':
    'Szablony odwołujące się do niej użyją domyślnej marki lub wartości zapasowych.',
  'brand.howTitle': 'Jak to działa',
  'brand.howText':
    'W edytorze wybierz kolor, czcionkę lub logo z sekcji marki — warstwa zapamięta odwołanie do slotu („Główny”, „Nagłówki”, „Logo”), a nie wartość. Zmień markę, a zaktualizują się wszystkie szablony. Wszystkie marki mają te same sloty, więc jeden zestaw szablonów działa dla każdego klienta: wybierz markę w automatyzacji lub przekaż brand_id w API.',
  'brand.colors': 'Kolory marki „{name}”',
  'brand.fonts': 'Czcionki marki „{name}”',
  'brand.logos': 'Logo marki „{name}”',
  'brand.detach': 'Odłącz od marki (zachowaj bieżący kolor)',
  'brand.useDefault': 'Domyślna marka ({name})',
  'brand.templateHint':
    'Marka, z którą szablon jest wyświetlany i renderowany, jeśli automatyzacja lub API nie wybierze innej.',
  'brand.editorHint': 'Ustaw raz kolory, czcionki i logo marki i używaj ich w każdym szablonie.',
  'brand.automationLabel': 'Marka',
  'brand.automationHint': 'Kolory, czcionki i logo marki dla wszystkich banerów tego uruchomienia.',
  'brand.templateBrand': 'Marka każdego szablonu',
  'brand.slot.primary': 'Główny',
  'brand.slot.secondary': 'Dodatkowy',
  'brand.slot.accent': 'Akcent',
  'brand.slot.background': 'Tło',
  'brand.slot.text': 'Tekst',
  'brand.slot.font-heading': 'Nagłówki',
  'brand.slot.font-body': 'Tekst główny',
  'brand.slot.logo': 'Logo',
  'brand.slot.logo-light': 'Jasne logo',
  'brand.slot.logo-icon': 'Ikona',
  'err.brandsPlan': 'Brand kit jest dostępny w planach Pro i Business',
  'err.brandsLimit': 'Twój plan pozwala na {limit} marek',
  'err.brandInvalid': 'Sprawdź wartości marki',
  'billing.fBrands': 'Brand kit',
  'landing.brandDemoTitle': 'Nowa kolekcja',
  'landing.brandDemoSub': 'Tylko do niedzieli',
  'landing.brandsTitle': 'Jeden zestaw szablonów — marki wszystkich klientów',
  'landing.brandsSubtitle':
    'Ustaw raz kolory, czcionki i logo marki. Szablony odwołują się do brand kitu: zmień kolor firmowy, a wszystkie banery się zaktualizują. Przełączaj markę klienta w automatyzacji lub jednym parametrem API.',
  'landing.brandsP1Title': 'Brand kit',
  'landing.brandsP1Text':
    'Kolory, czcionki, logo. W Pro jedna marka, w Business dowolnie wiele i przełączanie w locie.',
  'landing.brandsP2Title': 'Historia wersji z przywracaniem',
  'landing.brandsP2Text':
    'Każda sesja edycji jest zapisywana. Zepsuty szablon przed startem? Przywróć poprzednią wersję jednym kliknięciem.',
  'landing.brandsP3Title': 'Komentarze i akceptacja',
  'landing.brandsP3Text':
    'Uwagi bezpośrednio przy warstwie, statusy „do akceptacji” i „zaakceptowany”. API i kampanie rysują tylko zaakceptowaną wersję — zmiany nie trafią na produkcję bez zgody.',
  'landing.brandsP4Title': 'Dziennik aktywności',
  'landing.brandsP4Text':
    'Kto zmienił szablon, kto uruchomił automatyzację i jakim kluczem API — wszystko widać.',
  'landing.brandsDemoLabel': 'Jeden szablon · trzy marki',
  'landing.brandsDemoHint':
    'To żywy render: ten sam szablon, różne brand kity — kolory, czcionki, akcenty.',
  'landing.f7Title': 'Biblioteka mediów z folderami',
  'landing.f7Text':
    'Logo drużyn, zdjęcia produktów, tła — w folderach i z wyszukiwaniem. W arkuszu wpisz media:Drużyny/Arsenal, a trafi tam właściwy plik.',
  'landing.f8Title': 'Kody QR w stylu marki',
  'landing.f8Text':
    'Zaokrąglone punkty lub kropki, stylowe narożniki w kolorze, logo w środku — i nadal się skanuje.',
  'landing.f9Title': 'Arkusz dopasowuje się sam',
  'landing.f9Text':
    'Wgraj CSV lub wybierz arkusz Google z listy — kolumny same dopasują się do warstw: „Tytuł”, „Home Logo”, „Cena”.',
  'landing.q7': 'Czy mogę obsługiwać kilku klientów z różnymi markami?',
  'landing.a7':
    'Tak. W planie Business utwórz brand kit dla każdego klienta — kolory, czcionki, logo. Szablony odwołują się do marki, więc jeden zestaw działa dla wszystkich: wybierz markę w automatyzacji lub przekaż brand_id w API.',
  'landing.q8': 'Co jeśli ktoś zepsuje szablon?',
  'landing.a8':
    'W planie Business każda sesja edycji trafia do historii wersji: otwórz ją, obejrzyj podgląd i przywróć dowolną wersję jednym kliknięciem. Dziennik aktywności pokaże, kto i kiedy zmieniał szablon.',
  'editor.tabBrand': 'Marka',
  'brandPanel.empty':
    'Nie masz jeszcze brand kitu. Dodaj kolory, fonty i logo, a potem stosuj je jednym kliknięciem.',
  'brandPanel.toSelection': 'do zaznaczonych warstw ({n})',
  'brandPanel.toBackground': 'do tła płótna',
  'brandPanel.linked': 'Powiązano z marką: {n}',
  'brandPanel.nothingToLink': 'Żadne kolory ani fonty w szablonie nie pasują do marki',
  'brandPanel.edit': 'Edytuj brand kit',
  'brandPanel.clickHint':
    'Kliknij kolor, aby zastosować go {target}. Wartość pozostaje powiązana z marką.',
  'brandPanel.fontHint':
    'Kliknij, aby zastosować do zaznaczonego tekstu lub dodać nowy tekst tym fontem',
  'brandPanel.logoHint': 'Kliknij, aby zastąpić zaznaczony obraz lub dodać logo',
  'brandPanel.linkAll': 'Powiąż szablon z marką',
  'brandPanel.linkAllHint':
    'Znajdzie w szablonie kolory, fonty i logo marki i je powiąże — wtedy inna marka zmieni cały baner.',
  'brandImport.open': 'Importuj',
  'brandImport.title': 'Import brand kitu',
  'brandImport.description': 'Zbierzemy kolory, fonty i logo ze strony lub pliku Figma.',
  'brandImport.reviewHint': 'Sprawdź, co znaleźliśmy, i popraw w razie potrzeby.',
  'brandImport.back': 'Wstecz',
  'brandImport.replace': 'Zaktualizuj markę',
  'brandImport.create': 'Utwórz markę',
  'brandImport.website': 'Strona',
  'brandImport.siteLabel': 'Adres strony',
  'brandImport.siteHint': 'Pobierzemy kolory z CSS, fonty i logo ze strony głównej.',
  'brandImport.find': 'Znajdź',
  'brandImport.figmaConnect': 'Połącz Figmę, aby odczytać style i zmienne pliku.',
  'brandImport.figmaStep1':
    'W Figmie: Settings → Security → Personal access tokens → Generate new token (odczyt plików).',
  'brandImport.figmaStep2': 'Wklej token poniżej — jest przechowywany w postaci zaszyfrowanej.',
  'brandImport.connect': 'Połącz',
  'brandImport.figmaLabel': 'Link do pliku Figma',
  'brandImport.figmaHint':
    'Najlepiej plik z design systemem: style kolorów i tekstu, logo jako komponenty.',
  'brandImport.reading': 'Czytamy źródło…',
  'brandImport.name': 'Nazwa marki',
  'brandImport.saveTo': 'Zapisz jako',
  'brandImport.newBrand': 'Nowa marka',
  'brandImport.replaceBrand': 'Zastąp „{name}”',
  'brandImport.pickFor': 'Wybierz kolor',
  'brandImport.paletteHint': 'Znaleziona paleta — kliknij, aby przypisać kolor do wybranego slotu',
  'brandImport.fontMissing':
    'Fontu „{family}” nie ma w bibliotece — wybierz podobny lub prześlij plik fontu.',
  'brandImport.noLogos': 'Nie znaleziono logo — możesz dodać je później.',
  'brandImport.skipLogo': 'Nie importuj',
  'brandImport.saved': 'Brand kit zaimportowany',
  'integrations.figmaHint': 'Import brand kitu ze stylów i zmiennych plików Figma.',
  'err.siteHttp': 'Strona odpowiedziała błędem HTTP {status}.',
  'err.figmaLink': 'To nie wygląda na link do pliku Figma.',
  'err.figmaToken': 'Wklej token Figma.',
  'err.figmaNotFound': 'Nie znaleziono pliku Figma — sprawdź link.',
  'err.figmaForbidden': 'Brak dostępu: token jest nieprawidłowy lub konto nie ma dostępu do pliku.',
  'err.figmaError': 'Figma zwróciła błąd. Spróbuj później.',
  'brandDs.onPage': 'Na tej stronie',
  'brandDs.overview': 'Przegląd',
  'brandDs.typography': 'Typografia',
  'brandDs.usage': 'W użyciu',
  'brandDs.tagline': 'Kolory, fonty i logo marki w każdym banerze',
  'brandDs.colorsHint':
    'Kliknij próbkę, aby wybrać kolor, lub wpisz HEX. Szablony odwołują się do slotu (tokenu), a nie wartości, więc zmiana koloru zmieni wszystkie banery.',
  'brandDs.notSet': 'Nie ustawiono',
  'brandDs.contrast': 'Kontrast par',
  'brandDs.contrastHint':
    'Czytelność tekstu wg WCAG: AA od 4.5, AAA od 7, od 3 tylko dla dużego tekstu.',
  'brandDs.pairSample': 'Wyprzedaż −30%',
  'brandDs.largeOnly': 'duży',
  'brandDs.fail': 'słabo',
  'brandDs.typeHint':
    'Font nagłówków i tekstu. Warstwy z fontem marki zmienią się razem z brand kitem.',
  'brandDs.sampleHeadline': 'Wyrazisty baner w kilka sekund',
  'brandDs.sampleBody':
    'Szablony biorą kolory, fonty i logo z brand kitu, więc każdy render wygląda firmowo.',
  'brandDs.logosHint':
    'Główne logo na jasne tło, jasne na ciemne (pokazane na kolorze głównym), ikona do małych formatów.',
  'brandDs.usageHint':
    'Tak wyglądają szablony powiązane z marką. Podgląd od razu uwzględnia niezapisane zmiany.',
  'brandDs.sampleCta': 'Kup teraz',
  'brandDs.unsaved': 'Masz niezapisane zmiany',
  'brandDs.discard': 'Odrzuć',
  'keys.title': 'Skróty klawiszowe',
  'keys.description':
    'Działają, gdy fokus jest na płótnie. Klawisze literowe działają w każdym układzie.',
  'keys.general': 'Ogólne',
  'keys.layers': 'Warstwy',
  'keys.animation': 'Animacja',
  'keys.playPause': 'Odtwórz / pauza',
  'keys.frameStep': 'Klatka wstecz / naprzód',
  'keys.secondStep': 'Sekunda wstecz / naprzód',
  'keys.toStartEnd': 'Na początek / koniec',
  'keys.view': 'Widok',
  'keys.tools': 'Narzędzia',
  'keys.save': 'Zapisz',
  'keys.cut': 'Wytnij',
  'keys.selectAll': 'Zaznacz wszystko',
  'keys.delete': 'Usuń',
  'keys.deselect': 'Odznacz / wyjdź ze stosu',
  'keys.editText': 'Edytuj tekst',
  'keys.dblclick': 'dwuklik',
  'keys.cheatsheet': 'Ta ściąga',
  'editor.panelLeft': 'panel warstw',
  'editor.panelRight': 'panel właściwości',
  'editor.panelBottom': 'oś czasu i scenorys',
  'editor.panelShow': 'Pokaż {panel}',
  'editor.panelHide': 'Zwiń {panel}',
  'editor.focus': 'Skupienie na podglądzie: zwiń wszystkie panele',
  'editor.focusExit': 'Przywróć panele',
  'editor.panels': 'Panele',
  'editor.timelineResize': 'Przeciągnij, aby zmienić wysokość',
  'keys.nudge': 'Przesuń o 1 px',
  'keys.nudge10': 'Przesuń o 10 px',
  'keys.forward': 'Przesuń do przodu',
  'keys.backward': 'Przesuń do tyłu',
  'keys.front': 'Na wierzch',
  'keys.back': 'Na spód',
  'keys.hideShow': 'Ukryj / pokaż',
  'keys.lockUnlock': 'Zablokuj / odblokuj',
  'keys.keepRatio': 'Zachowaj proporcje',
  'keys.rotateStep': 'Obrót co 15°',
  'keys.distances': 'Odległości do sąsiadów',
  'keys.drag': 'przeciągnij',
  'keys.rotate': 'obracaj',
  'keys.wheel': 'kółko',
  'keys.zoomWheel': 'Powiększ w miejscu kursora',
  'keys.pan': 'Przesuń płótno',
  'keys.select': 'Zaznaczanie',
  'keys.body': 'Tekst',
  'plan.from': 'Dostępne od planu {plan}',
  'templates.placidFonts':
    'Nie udało się pobrać fontów: {fonts}. Warstwy już ich używają — prześlij pliki w sekcji Fonty.',
  'templates.placidImages': '{n} obrazów nadal wskazuje na Placid — nie udało się ich pobrać.',
  'templates.placidSkipped': 'Pominięto nieobsługiwane elementy: {types}',
  'templates.badJson': 'Plik nie jest poprawnym JSON',
  'err.placidFormat': 'Plik nie wygląda na eksport szablonu Placid',
  'consent.title': 'Używamy plików cookie',
  'consent.text':
    'Niezbędne pliki cookie utrzymują Cię zalogowanym. Za Twoją zgodą używamy też Google Analytics, by ulepszać serwis. Bez plików reklamowych.',
  'consent.accept': 'Akceptuj wszystkie',
  'consent.essentialOnly': 'Tylko niezbędne',
  'consent.customize': 'Dostosuj',
  'consent.save': 'Zapisz wybór',
  'consent.settingsTitle': 'Ustawienia plików cookie',
  'consent.settingsText':
    'Wybierz, na co się zgadzasz. Możesz to zmienić w każdej chwili w stopce lub profilu.',
  'consent.essential': 'Niezbędne',
  'consent.essentialText':
    'Sesja logowania, ochrona przed fałszowaniem żądań, język i wybrana przestrzeń. Bez nich serwis nie działa.',
  'consent.always': 'Zawsze aktywne',
  'consent.analytics': 'Analityka (Google Analytics)',
  'consent.analyticsText':
    'Pseudonimowe statystyki odwiedzin: które strony są otwierane i skąd przychodzą goście. Pliki _ga do 2 lat; Google przechowuje dane 14 miesięcy.',
  'consent.more': 'Więcej w dokumencie',
  'consent.link': 'Ustawienia cookie',
  'privacy.title': 'Prywatność i dane',
  'privacy.text': 'Pobierz kopię swoich danych, zmień ustawienia cookie lub usuń konto.',
  'privacy.export': 'Pobierz moje dane',
  'privacy.delete': 'Usuń konto',
  'privacy.deleteTitle': 'Usunąć konto na zawsze?',
  'privacy.deleteText':
    'Konto, Twoje dane i przestrzenie, z których korzystasz tylko Ty (z szablonami i plikami), zostaną trwale usunięte. Najpierw możesz pobrać kopię danych.',
  'privacy.deleteConfirm': 'Usuń na zawsze',
  'privacy.blocked': 'Najpierw rozwiąż kwestię przestrzeni:',
  'privacy.blocker.transferOwnership':
    'jesteś jedynym właścicielem, a są tam członkowie — wyznacz innego właściciela',
  'privacy.blocker.cancelSubscription': 'aktywna subskrypcja — anuluj ją w Plan i płatności',
  'privacy.willDelete': 'Zostaną usunięte przestrzenie:',
  'privacy.willLeave': 'Opuścisz przestrzenie:',
  'privacy.typeEmail': 'Wpisz {email}, aby potwierdzić',
  'err.confirmEmail': 'Wpisz swój email, aby potwierdzić',
  'brandDs.sampleQuote':
    'Wypuściliśmy 300 banerów na wyprzedaż w jeden wieczór — wszystkie w naszym stylu.',
  'brandDs.sampleAuthor': 'Anna Koval',
  'brandDs.sampleRole': 'Dyrektor artystyczna',
  'brandDs.sampleDate': '24 maja',
  'brandDs.samplePlace': 'Online · 19:00',
  'brandDs.sampleNew': 'Nowość',
  'preview.fake': 'Losowe dane',
  'preview.fakeRun': 'Losuj i renderuj',
  'preview.fakeHint':
    'Teksty dobierane są po nazwie warstwy (price, date, team, title…), zdjęcia to darmowe fotografie Unsplash przez Lorem Picsum, logo — DiceBear.',
  'gallery.cat.sport': 'Mecze i turnieje',
  'fonts.cat.all': 'Wszystkie',
  'fonts.cat.sans-serif': 'Bezszeryfowe',
  'fonts.cat.serif': 'Szeryfowe',
  'fonts.cat.display': 'Ozdobne',
  'fonts.cat.handwriting': 'Odręczne',
  'fonts.cat.monospace': 'Mono',
  'stock.myFiles': 'Moje pliki',
  'stock.photos': 'Zdjęcia Unsplash',
  'stock.search': 'Szukaj darmowych zdjęć (najlepiej po angielsku)',
  'stock.more': 'Więcej zdjęć',
  'stock.error': 'Nie udało się wczytać zdjęć. Spróbuj później.',
  'stock.credit':
    'Darmowe zdjęcia do użytku komercyjnego; autor jest podany w opisie warstwy. Źródło:',
  'stock.idea.coffee': 'coffee',
  'stock.idea.city': 'city night',
  'stock.idea.sport': 'football stadium',
  'stock.idea.food': 'food flat lay',
  'stock.idea.nature': 'mountains',
  'stock.idea.people': 'smiling woman',
  'err.stockOff': 'Wyszukiwanie zdjęć nie jest skonfigurowane',
  'err.stockLimit': 'Osiągnięto limit Unsplash, spróbuj później',
  'err.stockError': 'Unsplash zwrócił błąd, spróbuj później',
  'motion.mode': 'Animacja',
  'motion.modeHint': 'Animuj szablon do wideo, GIF-ów i banerów animowanych',
  'motion.back': 'Wróć do projektu',
  'motion.tabDesign': 'Projekt',
  'motion.tabDesignHint':
    'Tekst, czcionka, kolory i rozmiar warstwy — prosto w animacji. Dwuklik na tekście na scenie — edycja w miejscu',
  'motion.tabMotion': 'Animacja',
  'motion.sceneGraphics': 'Grafika ruchoma sceny',
  'motion.sceneGraphicsHint': 'Otwórz w animacji, aby edytować tekst i ustawienia',
  'motion.play': 'Odtwórz',
  'motion.pause': 'Pauza',
  'motion.animate': 'Ożyw',
  'motion.animateHint':
    'Animuje wszystkie warstwy w wybranym stylu. Ręczne ustawienia zostaną zastąpione.',
  'motion.style': 'Styl ruchu',
  'motion.clear': 'Usuń animację',
  'motion.empty':
    'Szablon jest na razie statyczny. Wybierz styl i kliknij „Ożyw” albo ustaw każdą warstwę.',
  'motion.video': 'Wideo',
  'motion.duration': 'Czas trwania',
  'motion.fps': 'Kl./s',
  'motion.loops': 'Powtórzenia banera',
  'motion.forever': 'W nieskończoność',
  'motion.scenes': 'Sceny',
  'motion.scenesHint':
    'Sceny są pokazywane po kolei jak klatki banera HTML5. Warstwy bez sceny są widoczne cały czas.',
  'motion.addScene': 'Dodaj scenę',
  'motion.sceneN': 'Scena {n}',
  'motion.transition': 'Przejście',
  'motion.none': 'Brak',
  'motion.enter': 'Wejście',
  'motion.emphasis': 'Akcent',
  'motion.exit': 'Wyjście',
  'motion.delay': 'Opóźnienie',
  'motion.beforeEnd': 'Przed końcem',
  'motion.length': 'Długość',
  'motion.easing': 'Krzywa',
  'motion.easingDefault': 'Jak w presecie',
  'motion.repeat': 'Powtórzenia',
  'motion.repeatHint': '0 — do końca sceny',
  'motion.gap': 'Przerwa',
  'motion.split': 'Tekst w częściach',
  'motion.split_none': 'Całość',
  'motion.split_line': 'Linie',
  'motion.split_word': 'Słowa',
  'motion.split_char': 'Litery',
  'motion.stagger': 'Odstęp',
  'motion.order': 'Kolejność',
  'motion.order_start': 'Od początku',
  'motion.order_end': 'Od końca',
  'motion.order_center': 'Od środka',
  'motion.order_edges': 'Od krawędzi',
  'motion.order_random': 'Losowo',
  'motion.scene': 'Scena',
  'motion.wholeVideo': 'Całe wideo',
  'motion.layerHint': 'Wybierz warstwę na liście lub osi czasu, aby ustawić jej ruch.',
  'motion.dir_up': 'W górę',
  'motion.dir_down': 'W dół',
  'motion.dir_left': 'W lewo',
  'motion.dir_right': 'W prawo',
  'motion.sec': 's',
  'motion.opener': 'Początek',
  'motion.layerStyle': 'Ruch warstw',
  'motion.noOpener': 'Bez otwarcia',
  'motion.pickHint':
    'Otwarcie, ruch warstw, akcenty i zakończenie się uzupełniają; wybór działa od razu.',
  'motion.openerPickHint': 'Grafika na początku filmu, nad projektem. Najedź, aby odtworzyć.',
  'motion.stylePickHint': 'Jak warstwy projektu wchodzą i się poruszają. Najedź, aby odtworzyć.',
  'motion.outro': 'Zakończenie',
  'motion.noOutro': 'Bez zakończenia',
  'motion.outroPickHint':
    'Jak kończy się film: plansza z wezwaniem, skupienie na ofercie, pętla. Najedź, aby odtworzyć.',
  'motion.accents': 'Akcenty',
  'motion.accentsHint':
    'Momenty w środku filmu, powiązane z elementami. Bez swojego elementu akcent nic nie robi.',
  'motion.customBadge': 'Twój',
  'motion.deletePresetTitle': 'Usunąć preset?',
  'motion.deletePresetText':
    'Preset zniknie z list. Szablony już nim animowane się nie zmienią: mają własną kopię.',
  'motion.soundBarHint':
    'Przeciągnij, aby przesunąć; krawędzie przycinają początek i koniec; z Shift dźwięk przesuwa się w odcinku; Alt ignoruje bit',
  'motion.splitSound': 'Przetnij',
  'motion.splitSoundHint': 'Przetnij dźwięk w miejscu głowicy (S)',
  'motion.splitSoundOutside': 'Ustaw głowicę wewnątrz wybranego dźwięku',
  'motion.removeSound': 'Usuń dźwięk',
  'motion.oneScene': 'jedna',
  'admin.settings': 'Ustawienia',
  'admin.settingsSaved': 'Zapisano',
  'backup.tab': 'Przeniesienie serwera',
  'backup.exportTitle': 'Pobierz kopię zapasową',
  'backup.exportText':
    'Jeden ZIP z całą bazą (użytkownicy, przestrzenie, szablony, automatyzacje, integracje, historia) i wszystkimi plikami. Wgraj go w panelu admina nowego serwera.',
  'backup.includeFiles': 'Z plikami (odznacz, gdy oba serwery używają tego samego S3)',
  'backup.download': 'Pobierz kopię',
  'backup.importTitle': 'Przywróć z kopii',
  'backup.importText':
    'Zastępuje wszystkie dane tego serwera danymi z kopii. Wersja Bannermatic i ENCRYPTION_KEY muszą być takie jak na starym serwerze. Konta i sesje przenoszą się razem z bazą.',
  'backup.chooseFile': 'Wybierz ZIP',
  'backup.restore': 'Przywróć',
  'backup.confirmTitle': 'Zastąpić wszystkie dane tego serwera?',
  'backup.confirmText':
    'Wszyscy użytkownicy, szablony i ustawienia zostaną zastąpione danymi z kopii. Tego nie można cofnąć.',
  'backup.keyHint':
    'ENCRYPTION_KEY jest tu inny: połączone konta Google, S3 i inne sekrety się nie otworzą. Lepiej skopiuj ENCRYPTION_KEY ze starego serwera i uruchom ten ponownie.',
  'backup.ignoreKey': 'Przywróć mimo to (integracje trzeba będzie połączyć ponownie)',
  'backup.restored':
    'Przywrócono: użytkownicy {users}, pliki {files}. Jeśli pojawi się logowanie, użyj konta ze starego serwera.',
  'err.backupInvalid': 'To nie jest kopia Bannermatic.',
  'err.backupVersion':
    'Kopia pochodzi z innej wersji Bannermatic. Najpierw zaktualizuj oba serwery do tej samej wersji.',
  'err.backupKey': 'ENCRYPTION_KEY różni się od starego serwera.',
  'admin.serverVideo': 'Renderowanie wideo na serwerze',
  'admin.serverVideoPlans': 'Plany, które mogą renderować wideo na serwerze',
  'admin.serverVideoPlansHint':
    'Pozostałe plany renderują wideo tylko w przeglądarce użytkownika, nawet gdy render na serwerze jest włączony.',
  'admin.serverVideoOffHint':
    'Wyłączone dla wszystkich. Wideo (MP4, WebM, GIF) renderuje się tylko na komputerze użytkownika w edytorze. API i automatyzacje z formatami wideo dostają błąd, obrazy działają normalnie.',
  'admin.serverVideoOnHint':
    'Włączone dla wszystkich. Wideo renderuje się na Twoich serwerach: z edytora, API i automatyzacji. Jeden klip 5 s 1080×1080 to około 20 vCPU·s.',
  'browserRender.serverOffNoDevice':
    'Wideo renderuje się teraz tylko na komputerze użytkownika, a ta przeglądarka tego nie potrafi. Otwórz edytor w Chrome lub Edge na komputerze.',
  'automation.serverVideoOff':
    'Formaty wideo są niedostępne: renderowanie wideo na serwerze jest teraz wyłączone. Wideo zrobisz w edytorze przyciskiem „Generuj”.',
  'err.serverVideoOff':
    'Renderowanie wideo na serwerze jest wyłączone. Zrób wideo w edytorze: „Generuj” → na tym komputerze.',
  'resize.videoFormats': 'Formaty do social mediów',
  'motion.easingHint':
    'Jak zmienia się prędkość ruchu: w poziomie czas, w pionie droga. Najedź, aby zobaczyć.',
  'video.galleryHint':
    'Gotowe reklamy wideo ze scenami, przejściami i montażem. Najedź na kartę, aby obejrzeć, wybierz format i podmień zdjęcia i teksty.',
  'video.hoverToPlay': 'Najedź, aby odtworzyć',
  'video.cat.basic': 'Podstawowe struktury',
  'video.cat.sale': 'Wyprzedaże',
  'video.cat.product': 'Produkt',
  'video.cat.fashion': 'Moda',
  'video.cat.food': 'Jedzenie',
  'video.cat.realestate': 'Nieruchomości',
  'video.cat.travel': 'Podróże',
  'video.cat.fitness': 'Fitness',
  'video.cat.event': 'Wydarzenia',
  'video.cat.tech': 'Aplikacje i IT',
  'video.cat.beauty': 'Uroda',
  'video.cat.auto': 'Motoryzacja',
  'video.cat.hiring': 'Rekrutacja',
  'video.cat.holiday': 'Święta',
  'video.cat.social': 'Social media i opinie',
  'video.cat.motion': 'Motion design',
  'api.videoHelp':
    'filmy i animowane szablony (render trwa dłużej: użyj ?wait=false i webhook_url). Warstwa zdjęcia przyjmie link .mp4/.mov/.webm i odtworzy klip; przycinanie: video_start, video_end (s), video_speed, video_muted.',
  'api.motionStyleHelp':
    'animuj szablon stylem (smooth, energetic, elegant, kinetic, sale…); bez niego użyta zostanie animacja szablonu.',
  'api.soundHelp':
    'muzyka i lektor filmu: link do pliku, null, aby usunąć, lub { url, volume, start, fade_out }.',
  'automation.videoFormatsHint':
    'MP4, WEBM i GIF renderują filmy i animacje. Statyczny szablon dostanie płynną animację automatycznie.',
  'motion.zoom': 'Powiększenie osi czasu',
  'motion.zoomIn': 'Przybliż',
  'motion.zoomOut': 'Oddal',
  'motion.zoomFit': 'Cały film',
  'motion.zoomHint': 'Powiększenie: Ctrl + kółko myszy. Przewijanie w bok: Shift + kółko',
  'templates.filterBanners': 'Banery',
  'templates.filterVideos': 'Filmy',
  'templates.kindVideo': 'Film',
  'templates.kindAnimated': 'Animacja',
  'templates.scenes': 'scen: {n}',
  'story.openHint': 'Kliknięcie: przejdź do sceny. Dwuklik lub ołówek: otwórz ją w projekcie',
  'story.editDesign': 'Edytuj projekt sceny',
  'sound.micInsecure':
    'Przeglądarka udostępnia mikrofon tylko stronom https lub localhost. Otwórz edytor przez https.',
  'sound.micMissing': 'Nie znaleziono mikrofonu. Podłącz go i spróbuj ponownie.',
  'video.new': 'Nowy film',
  'video.fmt.vertical': 'Reels, TikTok, Shorts',
  'video.fmt.portrait': 'Feed, 4:5',
  'video.fmt.square': 'Kwadrat',
  'video.fmt.wide': 'YouTube, strona',
  'video.recipe.sale': 'Wyprzedaż',
  'video.recipe.saleHint': 'Haczyk, produkt, cena z rabatem, wezwanie',
  'video.recipe.launch': 'Nowość',
  'video.recipe.launchHint': 'Haczyk, produkt, trzy korzyści, wezwanie',
  'video.recipe.review': 'Opinia',
  'video.recipe.reviewHint': 'Cytat klienta, produkt, korzyści, wezwanie',
  'video.recipe.event': 'Wydarzenie',
  'video.recipe.eventHint': 'Haczyk, data i miejsce, co będzie, wezwanie',
  'video.scene.hook': 'Haczyk',
  'video.scene.product': 'Produkt',
  'video.scene.offer': 'Oferta',
  'video.scene.benefits': 'Korzyści',
  'video.scene.quote': 'Opinia',
  'video.scene.when': 'Kiedy i gdzie',
  'video.scene.cta': 'Wezwanie',
  'video.txt.hook.sale': 'Tylko 3 dni!',
  'video.txt.hook.launch': 'Poznaj nowość',
  'video.txt.hook.event': 'Nie przegap!',
  'video.txt.product': 'Nazwa produktu',
  'video.txt.oldPrice': '199 zł',
  'video.txt.price': '99 zł',
  'video.txt.benefit1': 'Darmowa dostawa',
  'video.txt.benefit2': 'Łatwe zwroty',
  'video.txt.benefit3': 'Zaufało nam 10 000+ klientów',
  'video.txt.quote': '„Najlepszy zakup roku”',
  'video.txt.author': 'Anna, klientka',
  'video.txt.date': '12 czerwca · 19:00',
  'video.txt.place': 'Online',
  'video.txt.cta.sale': 'Kup taniej',
  'video.txt.cta.launch': 'Dowiedz się więcej',
  'video.txt.cta.review': 'Wypróbuj',
  'video.txt.cta.event': 'Zarejestruj się',
  'safe.hint': 'Strefy bezpieczne: gdzie aplikacja zasłania film przyciskami i podpisem',
  'safe.off': 'Bez stref',
  'safe.zone': 'Strefy {app}',
  'sound.title': 'Głos i dźwięki',
  'sound.record': 'Nagraj głos',
  'sound.stop': 'Stop',
  'sound.upload': 'Prześlij dźwięk',
  'sound.hint':
    'Lektor, efekty, druga melodia. Zaczynają się od kursora, muzyka przycicha pod głosem.',
  'sound.recordingHint':
    'Nagrywanie razem z filmem. Słuchawki pomogą, by mikrofon nie łapał muzyki.',
  'sound.micDenied':
    'Brak dostępu do mikrofonu. Kliknij ikonę kłódki obok adresu strony, zezwól na mikrofon i spróbuj ponownie.',
  'sound.start': 'Początek',
  'sound.here': 'Do kursora',
  'sound.toPlayhead': 'Ustaw początek na kursorze',
  'sound.duck': 'Muzyka pod głosem',
  'sound.kind.voice': 'Głos',
  'sound.kind.music': 'Muzyka',
  'sound.kind.sfx': 'Efekt',
  'editor.videoSpeed': 'Prędkość',
  'editor.videoFitScene': 'Scena na długość klipu ({s} s)',
  'story.title': 'Scenorys',
  'story.emptyHint':
    'Podziel film na sceny: haczyk, produkt, korzyści, oferta, wezwanie do działania.',
  'story.make': 'Podziel na sceny',
  'story.add': 'Scena',
  'story.split': 'Przetnij tutaj',
  'story.addAfter': 'Nowa scena po tej',
  'story.moveEarlier': 'Przesuń wcześniej',
  'story.moveLater': 'Przesuń później',
  'story.cut': 'Cięcie',
  'story.toAll': 'Pokazuj we wszystkich scenach',
  'story.toScene': 'We wszystkich scenach. Kliknij, aby zostawić tylko w tej',
  'err.browserRenderPlan': 'Generowanie na własnym komputerze nie jest dostępne w tym planie.',
  'billing.fVideo': 'Wideo: {n} min miesięcznie ({m} min na Twoim komputerze)',
  'billing.videoPeriod': 'Wideo w bieżącym okresie',
  'billing.videoMin': '{n} min',
  'err.videoLimit':
    'Miesięczny limit wideo został wykorzystany ({used} z {limit} s w planie {plan}). Generowanie na Twoim komputerze zużywa limit 4 razy wolniej.',
  'browserRender.optionHint':
    'Wideo jest rysowane i kodowane w Twojej przeglądarce. Zużywa 4 razy mniej limitu wideo niż generowanie na serwerze.',
  'preview.deviceFree': 'Taniej: generowanie na Twoim komputerze zużywa 4 razy mniej limitu wideo.',
  'videoGen.title': 'Film z Twoich treści',
  'videoGen.hint': 'Twoje teksty, zdjęcia i marka — za każdym razem nowe filmy',
  'videoGen.headline': 'Nagłówek',
  'videoGen.brandName': 'Nazwa marki lub produktu',
  'videoGen.subline': 'Podtytuł',
  'videoGen.benefits': 'Zalety',
  'videoGen.perLine': 'Jedna w linii, do 5',
  'videoGen.stats': 'Liczby',
  'videoGen.statsHint': '„12k — subskrybentów”, jedna w linii',
  'videoGen.more': 'Oferta, cena, opinia, przycisk',
  'videoGen.offer': 'Oferta (−30%, 2 w cenie 1)',
  'videoGen.offerNote': 'Dopisek do oferty',
  'videoGen.price': 'Cena',
  'videoGen.oldPrice': 'Stara cena',
  'videoGen.quote': 'Opinia',
  'videoGen.author': 'Autor opinii',
  'videoGen.cta': 'Tekst przycisku',
  'videoGen.site': 'Strona lub konto',
  'videoGen.brandKit': 'Brand kit',
  'videoGen.brandKitHint': 'Kolory, fonty i logo marki',
  'videoGen.noBrand': 'Bez marki — losowa paleta',
  'videoGen.logo': 'Logo',
  'videoGen.noLogo': 'Bez logo',
  'videoGen.logoBrand': 'Z brand kitu',
  'videoGen.photos': 'Zdjęcia',
  'videoGen.photosHint': 'wybrano {n} · z biblioteki lub wgraj własne',
  'videoGen.generate': 'Generuj filmy',
  'videoGen.again': 'Więcej wariantów',
  'videoGen.needHeadline': 'Potrzebny nagłówek',
  'videoGen.variant': 'wariant {n}',
  'browserRender.option': 'Na tym komputerze (beta)',
  'browserRender.title': 'Generowanie na tym komputerze',
  'browserRender.prepare': 'Przygotowuję scenę…',
  'browserRender.sound': 'Miksuję dźwięk…',
  'browserRender.frames': 'Klatka {n} z {total}',
  'browserRender.paused': 'Pauza: karta jest ukryta. Wróć do niej, aby kontynuować.',
  'browserRender.finish': 'Zapisuję wideo…',
  'browserRender.keepOpen': 'Nie zamykaj ani nie minimalizuj karty podczas generowania.',
  'browserRender.speed': 'Szybkość zależy od Twojego komputera.',
  'browserRender.differs': 'Wynik może nieco różnić się od generowania na serwerze.',
  'browserRender.cancelled': 'Generowanie anulowane',
  'motion.music': 'Muzyka',
  'motion.noMusic': 'Bez muzyki',
  'motion.musicUpload': 'Prześlij utwór (MP3, M4A, WAV, OGG, FLAC)',
  'motion.musicHint':
    'Prześlij utwór, a znajdziemy jego tempo: „Ożyw” ustawi ruchy w rytm, a dźwięk trafi do MP4 i WEBM.',
  'motion.musicStart': 'Przesunięcie utworu',
  'motion.musicAt': 'Start',
  'motion.musicAtHint': 'Kiedy muzyka zaczyna grać w filmie',
  'motion.musicLength': 'Długość',
  'motion.musicLengthHint': 'Jak długo gra muzyka. Do końca filmu: wydłuża się razem z filmem',
  'motion.bpmHint':
    'Tempo utworu w uderzeniach na minutę. Wykryte automatycznie, można poprawić; 0 wyłącza siatkę.',
  'motion.fadeIn': 'Narastanie',
  'motion.fadeOut': 'Wyciszenie',
  'motion.beatSync': '„Ożyw” w rytm muzyki',
  'motion.syncNow': 'Dopasuj do rytmu',
  'motion.noBeat': 'Nie znaleziono równego rytmu. Wpisz BPM ręcznie, jeśli jest.',
  'err.audioUnreadable': 'Nie udało się odczytać dźwięku: prześlij MP3, M4A, WAV, OGG lub FLAC.',
  'motion.beats': 'Uderzenia',
  'motion.keys': 'Klatki kluczowe',
  'motion.keysHint':
    'Ustaw głowicę i przeciągnij warstwę na scenie, a klatka się zapisze. Przeciągnij w innym momencie, a warstwa przesunie się między nimi.',
  'motion.keyScale': 'Skala',
  'motion.keyRotate': 'Obrót',
  'motion.keyOpacity': 'Krycie',
  'motion.keyEasing': 'Do następnej',
  'motion.keyDelete': 'Usuń klatkę',
  'motion.keyAdd': 'Klatka tutaj',
  'motion.keysClear': 'Usuń wszystkie',
  'motion.openers': 'Otwarcia',
  'motion.styles': 'Style ruchu warstw',
  'motion.fx': 'Grafika',
  'motion.fxHint':
    'Panele, koła, konfetti, plansze i tła nad lub pod projektem. Kolory z szablonu.',
  'motion.addFx': '+ Dodaj grafikę',
  'motion.camera': 'Kamera',
  'motion.cameraHint': 'Ruchy całej kompozycji: najazd, odjazd, wstrząs, panorama.',
  'motion.addCamera': '+ Dodaj ruch kamery',
  'motion.start': 'Start',
  'motion.zLayer': 'Gdzie',
  'motion.zFront': 'Nad projektem',
  'motion.zBack': 'Pod warstwami (tło)',
  'motion.auto': 'Automatycznie',
  'motion.color_accent': 'Akcent szablonu',
  'motion.color_accent2': 'Drugi akcent',
  'motion.color_dark': 'Ciemny',
  'motion.color_light': 'Jasny',
  'motion.color_ink': 'Kontrast do tła',
  'motion.color_custom': 'Własny kolor',
  'motion.fxcat_text': 'Plansze',
  'motion.fxcat_cover': 'Zasłony',
  'motion.fxcat_accent': 'Akcenty',
  'motion.fxcat_ambient': 'Tła',
  'motion.keyBlur': 'Rozmycie',
  'sound.auto': 'Udźwiękowij automatycznie',
  'sound.autoAgain': 'Rozmieść efekty ponownie',
  'sound.autoClear': 'Usuń efekty automatyczne',
  'sound.autoHint':
    'Świst 0,4 s przed przejściem, uderzenie na cięciu, tyknięcie dla każdej lądującej litery, pisanie dla terminala i więcej. Twoje dźwięki zostają.',
  'sound.addSfx': 'Efekt',
  'sound.generateMusic': 'Wygeneruj muzykę',
  'sound.listen': 'Posłuchaj wersji',
  'sound.anotherTake': 'Inna wersja',
  'sound.useTake': 'Do wideo',
  'sound.bpmAuto': '0 — tempo dobiera styl',
  'sound.energy_calm': 'Spokojnie',
  'sound.energy_normal': 'Normalnie',
  'sound.energy_high': 'Mocno',
  'sound.generateMusicHint':
    'Każda wersja to nowy utwór: tonacja, groove, bas, melodia, intro, drop i przerwa; talerze trafiają w cięcia wideo. Bez praw autorskich.',
  'motion.fontAuto': 'Jak warstwa lub nagłówek',
  'motion.fontReset': 'Resetuj czcionkę',
  'motion.textFx': 'Efekt tekstu',
  'motion.textFxHint':
    'Efekt staje się częścią tej warstwy: ten sam tekst, czcionka i kolor, warstwa po prostu gra inaczej. Jego pasek jest w wierszu warstwy na osi czasu.',
  'motion.textFxApply': 'Zastosuj',
  'motion.poster': 'Okładka (miniatura i obraz)',
  'motion.textFxUntilEnd': '0 — dopóki warstwa jest na ekranie',
  'motion.textFxRemove': 'Usuń efekt',
  'motion.generator': 'Generator ruchu',
  'motion.generatorHint':
    'Ścieżki, fizyka i szum zapisują się jako klucze od głowicy — każdy można edytować.',
  'motion.genDistance': 'Zasięg',
  'motion.genAngle': 'Kąt',
  'motion.genGrow': 'Wzrost, %',
  'motion.genCycles': 'Cykle',
  'motion.genLength': 'Długość',
  'motion.genDirection': 'Kierunek',
  'motion.genOrient': 'Obracaj wzdłuż ścieżki',
  'motion.genApply': 'Zapisz klucze',
  'motion.repeater': 'Powiel warstwę',
  'motion.repeaterHint':
    'Kopie w siatce, w kole, w linii, spirali lub rozsypane, każda startuje nieco później.',
  'motion.repeatLayout': 'Układ',
  'motion.repeat_grid': 'Siatka',
  'motion.repeat_circle': 'Koło',
  'motion.repeat_line': 'Linia',
  'motion.repeat_spiral': 'Spirala',
  'motion.repeat_scatter': 'Rozsypanie',
  'motion.repeatCount': 'Ile',
  'motion.repeatCols': 'W rzędzie',
  'motion.repeatRadius': 'Promień',
  'motion.repeatAngle': 'Kąt',
  'motion.repeatGap': 'Odstęp',
  'motion.repeatStagger': 'Krok',
  'motion.repeatRotate': 'Obrót',
  'motion.repeatScale': 'Rozmiar',
  'motion.repeatOpacity': 'Krycie',
  'motion.repeatOrient': 'Obracaj na zewnątrz',
  'motion.repeatApply': 'Utwórz kopie ({n})',
  'motion.fxcat_interface': 'Interfejs i dane',
  'motion.fxcat_pattern': 'Wzory i cząsteczki',
  'motion.cost': 'Wideo renderuje się dłużej niż obraz, zwykle 10–30 sekund.',
};
